export default {
  'pages.superH.loadPlatformConfigsFailed': 'Failed to load {platform} configurations. Please retry.',
  'pages.superH.noPlatformConfigTitle': 'No {platform} configurations found',
  'pages.superH.noPlatformConfigDescription': 'Create at least two {platform} callback configurations for the source and target.',
  'pages.superH.platformSourcePlaceholder': 'Select one or more {platform} source configurations',
  'pages.superH.platformTargetPlaceholder': 'Select the receiving {platform} configuration',
  'pages.superH.collectClickRecords': 'Collect click records',
  'pages.adCallbackForm.tiktok.contentType': 'Content type',
  'pages.adCallbackForm.tiktok.contentTypeHelp': 'Used by regular and super callbacks. Contact, Lead and SubmitForm events omit commerce properties.',
  'pages.adCallbackForm.tiktok.contentType.product': 'Product (product)',
  'pages.adCallbackForm.tiktok.contentType.productGroup': 'Product group (product_group)',
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  'pages.overseas.batchDelete': 'Batch Delete',
  'pages.overseas.batchDeleteWithCount': 'Batch Delete ({count})',
  'pages.overseas.batchDeleteEmpty':
    'Select diversion services to delete first',
  'pages.overseas.batchDeleteConfirmTitle':
    'Delete the selected {count} diversion services?',
  'pages.overseas.batchDeleteConfirmContent':
    'This action cannot be undone. Confirm that the selected services are correct.',
  'pages.overseas.confirmDelete': 'Delete',
  'pages.overseas.cancel': 'Cancel',
  'pages.overseas.cancelSelection': 'Clear selection',
  'pages.overseas.batchDeleteSuccess': 'Deleted {count} diversion services',
  'pages.overseas.batchDeletePartial':
    'Deleted {success}; {failed} failed to delete',
  'pages.overseas.batchDeleteFailed': 'Batch delete failed',

  // Kakao pages
  'pages.kakao.title': 'Kakao Service Management',
  'pages.kakao.subtitle':
    'Manage Kakao overseas distribution services, support multiple domains and access rules',
  'pages.kakao.addLink': 'Add Link',
  'pages.kakao.refresh': 'Refresh',
  'pages.kakao.export': 'Export',
  'pages.kakao.name': 'Name',
  'pages.kakao.quantity': 'Quantity',
  'pages.kakao.configured': 'Configured',
  'pages.kakao.rule': 'Rule',
  'pages.kakao.ruleOrder': 'Order',
  'pages.kakao.ruleRandom': 'Random',
  'pages.kakao.lockIP': 'Lock IP',
  'pages.kakao.locked': 'Locked',
  'pages.kakao.unlocked': 'Unlocked',
  'pages.kakao.status': 'Status',
  'pages.kakao.enabled': 'Enabled',
  'pages.kakao.disabled': 'Disabled',
  'pages.kakao.createdAt': 'Created At',
  'pages.kakao.actions': 'Actions',
  'pages.kakao.copy': 'Copy',
  'pages.kakao.copySuccess': 'Link copied to clipboard',
  'pages.kakao.copyError': 'Copy failed',
  'pages.kakao.edit': 'Edit',
  'pages.kakao.delete': 'Delete',
  'pages.kakao.deleteConfirm': 'Are you sure to delete this item?',
  'pages.kakao.yes': 'Yes',
  'pages.kakao.no': 'No',
  'pages.kakao.addTitle': 'Add Link',
  'pages.kakao.editTitle': 'Edit Link',
  'pages.kakao.serviceName': 'Service Name',
  'pages.kakao.serviceNamePlaceholder': 'Please enter service name',
  'pages.kakao.serviceNameRequired': 'Please enter service name',
  'pages.kakao.domains': 'Links',
  'pages.kakao.domainsPlaceholder':
    'One per line, multiple lines separated by newline',
  'pages.kakao.domainsRequired': 'Please enter at least one link',
  'pages.kakao.domainsInvalid':
    'Domain format is incorrect, only kakao.com and its subdomains are allowed',
  'pages.kakao.deleteAccounts': 'Delete Accounts',
  'pages.kakao.deleteAccountsPlaceholder': 'Enter links/accounts to delete',
  'pages.kakao.deleteAccountsExtra':
    'Fill in links/accounts that need to be deleted',
  'pages.kakao.deleteAccountsRemoved': 'Removed {count} accounts',
  'pages.kakao.configuredCount': 'Configured',
  'pages.kakao.configuredLinks': 'links',
  'pages.kakao.accessRule': 'Access Rule',
  'pages.kakao.accessRulePlaceholder': 'Please select access rule',
  'pages.kakao.accessRuleRequired': 'Please select access rule',
  'pages.kakao.accessRuleOrder': 'Order - Access domains in order',
  'pages.kakao.accessRuleRandom': 'Random - Randomly select domain',
  'pages.kakao.fetchSuccess': 'Service list fetched successfully',
  'pages.kakao.fetchError': 'Failed to fetch service list',
  'pages.kakao.deleteSuccess': 'Deleted successfully',
  'pages.kakao.deleteError': 'Failed to delete',
  'pages.kakao.updateSuccess': 'Updated successfully',
  'pages.kakao.updateError': 'Failed to update',
  'pages.kakao.addSuccess': 'Added successfully',
  'pages.kakao.addError': 'Failed to add',
  'pages.kakao.exportDev': 'Export function is under development...',
  'pages.kakao.totalRecords': 'Total {total} records',
  'pages.kakao.duplicateRemoved':
    'Automatically removed {count} duplicate links',
  'pages.kakao.trafficDataSuccess': 'Traffic data loaded successfully',
  'pages.kakao.trafficDataError': 'Failed to load traffic data',
  'pages.kakao.resetConfirmTitle': 'Confirm reset',
  'pages.kakao.resetConfirmLine1': 'This action cannot be undone:',
  'pages.kakao.resetConfirmLine2': 'Are you sure you want to clear the visit records?',
  'pages.kakao.resetButton': 'Reset Data',
  'pages.kakao.resetSuccess': 'Statistics data has been fully cleared',
  'pages.kakao.updateLinkTitle': 'Edit Link Content',
  'pages.kakao.currentContent': 'Current content',
  'pages.kakao.newLinkPlaceholder': 'Enter the new link',
  'pages.kakao.linkEmpty': 'Link cannot be empty',
  'pages.kakao.linkUpdateSuccess': 'Link content updated successfully',
  'pages.kakao.unknownError': 'Unknown error',
  'pages.kakao.operationFailed': 'Operation failed',
  'pages.kakao.remarkTitle': 'Set Remark',
  'pages.kakao.remarkPlaceholder': 'Enter a remark',
  'pages.kakao.remarkSuccess': 'Remark updated successfully',
  'pages.kakao.dailyUV': 'Today UV/Yesterday UV',
  'pages.kakao.dailyUVTooltip': 'Unique visitors today / yesterday',
  'pages.kakao.workOrderIncrease': 'Today/Total Added',
  'pages.kakao.batchLock': 'Batch Lock',
  'pages.kakao.unset': 'Unset',
  'pages.kakao.stats': 'Visit Stats',
  'pages.kakao.trafficData': 'Traffic Data',
  'pages.kakao.interceptionConfig': 'Interception Config',
  'pages.kakao.generateQr': 'Generate QR Code',
  'pages.kakao.exportIp': 'Export IP',
  'pages.kakao.recreateShortLink': 'Please recreate the service to generate a short link',
  'pages.kakao.copyCampaignLink': 'Copy Campaign Link',
  'pages.kakao.moreActions': 'More Actions',
  'pages.kakao.shareService': 'Share Service',
  'pages.kakao.searchPlaceholder': 'Search service name',
  'pages.kakao.workOrderManagement': 'Work Order Management',
  'pages.kakao.favorite': 'Favorite',
  'pages.kakao.unfavorite': 'Unfavorite',
  'pages.kakao.favoriteOnly': 'Favorites Only',
  'pages.kakao.favoriteSuccess': 'Added to favorites',
  'pages.kakao.unfavoriteSuccess': 'Removed from favorites',
  'pages.kakao.favoriteToggleFailed': 'Failed to update favorite',
  'pages.kakao.viewAll': 'View All',
  'pages.kakao.workOrderOnly': 'Work Orders Only',
  'pages.kakao.batchDedupe': 'Batch Deduplication',
  'pages.kakao.myIpLibrary': 'My IP Library',
  'pages.kakao.lockIPTooltip':
    'When enabled, browser fingerprint plus IP deduplication ensures the same visitor sees only one routed contact',
  'pages.kakao.trafficStatsTitle': 'Traffic Data Stats - {name}',
  'pages.kakao.close': 'Close',
  'pages.kakao.refreshData': 'Refresh Data',
  'pages.kakao.showingRecords': 'Showing {filtered} / {total} records',
  'pages.kakao.customerLink': 'Customer Link',
  'pages.kakao.workOrderIds': 'Bound',
  'pages.kakao.percentage': 'Percentage%',
  'pages.kakao.disabledManual': 'Disabled (Manual)',
  'pages.kakao.disabledFlowOptimize': 'Disabled (Flow Optimized)',
  'pages.kakao.disabledAuto': 'Disabled (Automatic)',
  'pages.kakao.disabledManualTooltip':
    'Manually disabled accounts will not be automatically re-enabled by sync',
  'pages.kakao.disabledFlowOptimizeTooltip':
    'Disabled by flow optimization after reaching today’s work-order threshold; can only be re-enabled manually',
  'pages.kakao.disabledAutoTooltip':
    'Disabled by automatic rules and can be re-enabled manually',
  'pages.kakao.setRemark': 'Set Remark',
  'pages.kakao.batchLockTitle': 'Batch IP Lock Settings',
  'pages.kakao.batchLockDesc': 'Select the services that should share the same IP deduplication group',
  'pages.kakao.batchLockPlaceholder': 'Enter a group name (required)',
  'pages.kakao.selectedServices': '{count} services selected',
  'pages.kakao.exportSuccess': 'Export successful',
  'pages.kakao.pageRange': '{start}-{end} / {total}',
  'pages.kakao.batchDedupeRequired': 'Please select at least one service',
  'pages.kakao.batchDedupeSuccess': 'Successfully updated {count} services',
  'pages.kakao.unbindBatchLockConfirmTitle':
    'Unbind this service from the current deduplication group?',
  'pages.kakao.unbindBatchLockConfirmDesc':
    'After unbinding, this service will no longer belong to this batch deduplication group.',
  'pages.kakao.unbindBatchLockConfirmOk': 'Unbind',
  'pages.kakao.unbindBatchLockSuccess':
    'Batch deduplication binding has been removed',
  'pages.kakao.deviceRouting': 'Device Routing',
  'pages.kakao.deviceRoutingTitle': 'Device Routing - {name}',
  'pages.kakao.deviceRoutingSave': 'Save',
  'pages.kakao.deviceRoutingSaveSuccess': 'Device routing saved',
  'pages.kakao.deviceRoutingSaveError': 'Failed to save device routing',
  'pages.kakao.deviceRoutingNoLinks': 'No links available for this service',
  'pages.kakao.deviceRoutingLink': 'Link',
  'pages.kakao.deviceRoutingTagAll': 'All Devices',
  'pages.kakao.deviceRoutingTagIOS': 'iOS Only',
  'pages.kakao.deviceRoutingTagAndroid': 'Android Only',
  'pages.kakao.requestFailed': 'Request failed',
  'pages.kakao.maxDomains': 'No more than 5000 domains are allowed',

  // Line pages
  'pages.line.title': 'Line Service Management',
  'pages.line.subtitle':
    'Manage Line overseas distribution services, support multiple domains and access rules',
  'pages.line.addLink': 'Add Link',
  'pages.line.refresh': 'Refresh',
  'pages.line.export': 'Export',
  'pages.line.name': 'Name',
  'pages.line.quantity': 'Quantity',
  'pages.line.configured': 'Configured',
  'pages.line.rule': 'Rule',
  'pages.line.ruleOrder': 'Order',
  'pages.line.ruleRandom': 'Random',
  'pages.line.lockIP': 'Lock IP',
  'pages.line.locked': 'Locked',
  'pages.line.unlocked': 'Unlocked',
  'pages.line.status': 'Status',
  'pages.line.enabled': 'Enabled',
  'pages.line.disabled': 'Disabled',
  'pages.line.createdAt': 'Created At',
  'pages.line.actions': 'Actions',
  'pages.line.copy': 'Copy',
  'pages.line.copySuccess': 'Link copied to clipboard',
  'pages.line.copyError': 'Copy failed',
  'pages.line.edit': 'Edit',
  'pages.line.delete': 'Delete',
  'pages.line.deleteConfirm': 'Are you sure to delete this item?',
  'pages.line.yes': 'Yes',
  'pages.line.no': 'No',
  'pages.line.addTitle': 'Add Link',
  'pages.line.editTitle': 'Edit Link',
  'pages.line.serviceName': 'Service Name',
  'pages.line.serviceNamePlaceholder': 'Please enter service name',
  'pages.line.serviceNameRequired': 'Please enter service name',
  'pages.line.domains': 'Links',
  'pages.line.domainsPlaceholder':
    'One per line, multiple lines separated by newline',
  'pages.line.domainsRequired': 'Please enter at least one link',
  'pages.line.domainsInvalid':
    'Domain format is incorrect, only line.me and its official links are allowed',
  'pages.line.deleteAccounts': 'Delete Accounts',
  'pages.line.deleteAccountsPlaceholder': '@468rqiiq (one link or account per line)',
  'pages.line.deleteAccountsExtra':
    'Enter a full link or LINE ID. An @account removes its complete oaMessage link. This only applies to manually managed accounts, not work-order-bound accounts.',
  'pages.line.deleteAccountsRemoved': 'Removed {count} accounts',
  'pages.line.configuredCount': 'Configured',
  'pages.line.configuredLinks': 'links',
  'pages.line.accessRule': 'Access Rule',
  'pages.line.accessRulePlaceholder': 'Please select access rule',
  'pages.line.accessRuleRequired': 'Please select access rule',
  'pages.line.accessRuleOrder': 'Order - Access in sequence',
  'pages.line.accessRuleRandom': 'Random - Random selection',
  'pages.line.fetchSuccess': 'Service list fetched successfully',
  'pages.line.fetchError': 'Failed to fetch service list',
  'pages.line.deleteSuccess': 'Deleted successfully',
  'pages.line.deleteError': 'Failed to delete',
  'pages.line.updateSuccess': 'Updated successfully',
  'pages.line.updateError': 'Failed to update',
  'pages.line.addSuccess': 'Added successfully',
  'pages.line.addError': 'Failed to add',
  'pages.line.exportDev': 'Export function is under development...',
  'pages.line.totalRecords': 'Total {total} records',
  'pages.line.duplicateRemoved':
    'Automatically removed {count} duplicate links',
  'pages.line.trafficDataSuccess': 'Traffic data loaded successfully',
  'pages.line.trafficDataError': 'Failed to load traffic data',
  'pages.line.resetConfirmTitle': 'Confirm reset',
  'pages.line.resetConfirmLine1': 'This action cannot be undone:',
  'pages.line.resetConfirmLine2': 'Are you sure you want to clear the visit records?',
  'pages.line.resetButton': 'Reset Data',
  'pages.line.resetSuccess': 'Statistics data has been fully cleared',
  'pages.line.updateLinkTitle': 'Edit Link Content',
  'pages.line.currentContent': 'Current content',
  'pages.line.newLinkPlaceholder': 'Enter the new link or ID',
  'pages.line.linkEmpty': 'Link or ID cannot be empty',
  'pages.line.linkUpdateSuccess': 'Link content updated successfully',
  'pages.line.unknownError': 'Unknown error',
  'pages.line.operationFailed': 'Operation failed',
  'pages.line.remarkTitle': 'Set Remark',
  'pages.line.remarkPlaceholder': 'Enter a remark',
  'pages.line.remarkSuccess': 'Remark updated successfully',
  'pages.line.dailyUV': 'Today UV/Yesterday UV',
  'pages.line.dailyUVTooltip': 'Unique visitors today / yesterday',
  'pages.line.workOrderIncrease': 'Today/Total Added',
  'pages.line.batchLock': 'Batch Lock',
  'pages.line.unset': 'Unset',
  'pages.line.stats': 'Visit Stats',
  'pages.line.trafficData': 'Traffic Data',
  'pages.line.interceptionConfig': 'Interception Config',
  'pages.line.generateQr': 'Generate QR Code',
  'pages.line.exportIp': 'Export IP',
  'pages.line.recreateShortLink': 'Please recreate the service to generate a short link',
  'pages.line.copyCampaignLink': 'Copy Campaign Link',
  'pages.line.moreActions': 'More Actions',
  'pages.line.shareService': 'Share Service',
  'pages.line.searchPlaceholder': 'Search name, code, account, link, or remark',
  'pages.line.workOrderManagement': 'Work Order Management',
  'pages.line.favorite': 'Favorite',
  'pages.line.unfavorite': 'Unfavorite',
  'pages.line.favoriteOnly': 'Favorites Only',
  'pages.line.favoriteSuccess': 'Added to favorites',
  'pages.line.unfavoriteSuccess': 'Removed from favorites',
  'pages.line.favoriteToggleFailed': 'Failed to update favorite',
  'pages.line.viewAll': 'View All',
  'pages.line.workOrderOnly': 'Work Orders Only',
  'pages.line.batchDedupe': 'Batch Deduplication',
  'pages.line.myIpLibrary': 'My IP Library',
  'pages.line.lockIPTooltip':
    'When enabled, browser fingerprint plus IP deduplication ensures the same visitor sees only one routed contact',
  'pages.line.trafficStatsTitle': 'Traffic Data Stats - {name}',
  'pages.line.close': 'Close',
  'pages.line.refreshData': 'Refresh Data',
  'pages.line.showingRecords': 'Showing {filtered} / {total} records',
  'pages.line.customerLink': 'Customer Link',
  'pages.line.workOrderIds': 'Bound',
  'pages.line.percentage': 'Percentage%',
  'pages.line.disabledManual': 'Disabled (Manual)',
  'pages.line.disabledFlowOptimize': 'Disabled (Flow Optimized)',
  'pages.line.disabledAuto': 'Disabled (Automatic)',
  'pages.line.disabledManualTooltip':
    'Manually disabled accounts will not be automatically re-enabled by sync',
  'pages.line.disabledFlowOptimizeTooltip':
    'Disabled by flow optimization after reaching today’s work-order threshold; can only be re-enabled manually',
  'pages.line.disabledAutoTooltip':
    'Disabled by automatic rules and can be re-enabled manually',
  'pages.line.setRemark': 'Set Remark',
  'pages.line.batchLockTitle': 'Batch IP Lock Settings',
  'pages.line.batchLockDesc': 'Select the services that should share the same IP deduplication group',
  'pages.line.batchLockPlaceholder': 'Enter a group name (required)',
  'pages.line.selectedServices': '{count} services selected',
  'pages.line.exportSuccess': 'Export successful',
  'pages.line.pageRange': '{start}-{end} / {total}',
  'pages.line.batchDedupeRequired': 'Please select at least one service',
  'pages.line.batchDedupeSuccess': 'Successfully updated {count} services',
  'pages.line.unbindBatchLockConfirmTitle':
    'Unbind this service from the current deduplication group?',
  'pages.line.unbindBatchLockConfirmDesc':
    'After unbinding, this service will no longer belong to this batch deduplication group.',
  'pages.line.unbindBatchLockConfirmOk': 'Unbind',
  'pages.line.unbindBatchLockSuccess':
    'Batch deduplication binding has been removed',
  'pages.line.deviceRouting': 'Device Routing',
  'pages.line.deviceRoutingTitle': 'Device Routing - {name}',
  'pages.line.deviceRoutingSave': 'Save',
  'pages.line.deviceRoutingSaveSuccess': 'Device routing saved',
  'pages.line.deviceRoutingSaveError': 'Failed to save device routing',
  'pages.line.deviceRoutingNoLinks': 'No links available for this service',
  'pages.line.deviceRoutingLink': 'Link',
  'pages.line.deviceRoutingTagAll': 'All Devices',
  'pages.line.deviceRoutingTagIOS': 'iOS Only',
  'pages.line.deviceRoutingTagAndroid': 'Android Only',
  'pages.line.requestFailed': 'Request failed',
  'pages.line.maxDomains': 'No more than 5000 entries are allowed',
  'pages.line.idRequired': 'Please enter at least one Line ID',
  'pages.line.idLabel': 'Line ID',
  'pages.line.redirectType': 'Redirect Type',
  'pages.line.redirectTypeRequired': 'Please select a redirect type',
  'pages.line.redirectTypePlaceholder': 'Please select a redirect type',
  'pages.line.redirectLink': 'Link Redirect',
  'pages.line.redirectId': 'Line ID',
  'pages.line.idPlaceholder': 'One LineID per line',
  'pages.line.idLengthInvalid': 'Line ID must be 4-20 characters: {value}',
  'pages.line.idFormatInvalid':
    'Line ID can only contain a leading @, letters, numbers, dots, underscores, and hyphens: {value}',
  'pages.line.linkFormatInvalid':
    'Invalid link format, only official Line links are allowed: {value}',

  // Telegram pages
  'pages.tg.title': 'Telegram Distribution Management',
  'pages.tg.subtitle': 'Telegram Distribution Management',
  'pages.tg.addLink': 'Add Service',
  'pages.tg.refresh': 'Refresh',
  'pages.tg.name': 'Name',
  'pages.tg.quantity': 'Quantity',
  'pages.tg.rule': 'Access Rule',
  'pages.tg.ruleOrder': 'Order',
  'pages.tg.ruleRandom': 'Random',
  'pages.tg.lockIP': 'IP Lock',
  'pages.tg.locked': 'Locked',
  'pages.tg.unlocked': 'Unlocked',
  'pages.tg.status': 'Status',
  'pages.tg.enabled': 'Enabled',
  'pages.tg.disabled': 'Disabled',
  'pages.tg.createdAt': 'Created At',
  'pages.tg.actions': 'Actions',
  'pages.tg.copySuccess': 'Copied successfully',
  'pages.tg.copyError': 'Copy failed',
  'pages.tg.edit': 'Edit',
  'pages.tg.delete': 'Delete',
  'pages.tg.deleteConfirm': 'Are you sure you want to delete this service?',
  'pages.tg.addTitle': 'Add Service',
  'pages.tg.editTitle': 'Edit Service',
  'pages.tg.serviceName': 'Service Name',
  'pages.tg.serviceNamePlaceholder': 'Please enter service name',
  'pages.tg.serviceNameRequired': 'Please enter service name',
  'pages.tg.fetchSuccess': 'Telegram services loaded successfully',
  'pages.tg.fetchError': 'Failed to load data',
  'pages.tg.deleteSuccess': 'Deleted successfully',
  'pages.tg.deleteError': 'Failed to delete',
  'pages.tg.updateSuccess': 'Updated successfully',
  'pages.tg.updateError': 'Failed to update',
  'pages.tg.addSuccess': 'Created successfully',
  'pages.tg.addError': 'Failed to create',
  'pages.tg.duplicateRemoved':
    'Automatically removed {count} duplicate entries',
  'pages.tg.deleteAccounts': 'Delete Accounts',
  'pages.tg.deleteAccountsPlaceholder': 'Enter links/accounts to delete',
  'pages.tg.deleteAccountsExtra':
    'Fill in links/accounts that need to be deleted',
  'pages.tg.deleteAccountsRemoved': 'Removed {count} accounts',
  'pages.tg.totalRecords': 'Total {total} records',
  'pages.tg.trafficDataSuccess': 'Traffic data loaded successfully',
  'pages.tg.trafficDataError': 'Failed to load traffic data',
  'pages.tg.resetConfirmTitle': 'Confirm reset',
  'pages.tg.resetConfirmLine1': 'This action cannot be undone:',
  'pages.tg.resetConfirmLine2': 'Are you sure you want to clear the visit records?',
  'pages.tg.resetButton': 'Reset Data',
  'pages.tg.resetSuccess': 'Statistics data has been fully cleared',
  'pages.tg.updateLinkTitle': 'Edit Link Content',
  'pages.tg.currentContent': 'Current content',
  'pages.tg.newLinkPlaceholder': 'Enter the new link or username',
  'pages.tg.linkEmpty': 'Link or username cannot be empty',
  'pages.tg.linkUpdateSuccess': 'Link content updated successfully',
  'pages.tg.unknownError': 'Unknown error',
  'pages.tg.operationFailed': 'Operation failed',
  'pages.tg.remarkTitle': 'Set Remark',
  'pages.tg.remarkPlaceholder': 'Enter a remark',
  'pages.tg.remarkSuccess': 'Remark updated successfully',
  'pages.tg.dailyUV': 'Today UV/Yesterday UV',
  'pages.tg.dailyUVTooltip': 'Unique visitors today / yesterday',
  'pages.tg.workOrderIncrease': 'Today/Total Added',
  'pages.tg.batchLock': 'Batch Lock',
  'pages.tg.unset': 'Unset',
  'pages.tg.stats': 'Visit Stats',
  'pages.tg.trafficData': 'Traffic Data',
  'pages.tg.interceptionConfig': 'Interception Config',
  'pages.tg.generateQr': 'Generate QR Code',
  'pages.tg.exportIp': 'Export IP',
  'pages.tg.recreateShortLink': 'Please recreate the service to generate a short link',
  'pages.tg.copyCampaignLink': 'Copy Campaign Link',
  'pages.tg.moreActions': 'More Actions',
  'pages.tg.shareService': 'Share Service',
  'pages.tg.searchPlaceholder': 'Search name, code, account, link, or remark',
  'pages.tg.workOrderManagement': 'Work Order Management',
  'pages.tg.favorite': 'Favorite',
  'pages.tg.unfavorite': 'Unfavorite',
  'pages.tg.favoriteOnly': 'Favorites Only',
  'pages.tg.favoriteSuccess': 'Added to favorites',
  'pages.tg.unfavoriteSuccess': 'Removed from favorites',
  'pages.tg.favoriteToggleFailed': 'Failed to update favorite',
  'pages.tg.viewAll': 'View All',
  'pages.tg.workOrderOnly': 'Work Orders Only',
  'pages.tg.batchDedupe': 'Batch Deduplication',
  'pages.tg.myIpLibrary': 'My IP Library',
  'pages.tg.lockIPTooltip':
    'When enabled, browser fingerprint plus IP deduplication ensures the same visitor sees only one routed contact',
  'pages.tg.trafficStatsTitle': 'Traffic Data Stats - {name}',
  'pages.tg.close': 'Close',
  'pages.tg.refreshData': 'Refresh Data',
  'pages.tg.showingRecords': 'Showing {filtered} / {total} records',
  'pages.tg.customerLink': 'Customer Link',
  'pages.tg.workOrderIds': 'Bound',
  'pages.tg.percentage': 'Percentage%',
  'pages.tg.disabledManual': 'Disabled (Manual)',
  'pages.tg.disabledFlowOptimize': 'Disabled (Flow Optimized)',
  'pages.tg.disabledAuto': 'Disabled (Automatic)',
  'pages.tg.disabledManualTooltip':
    'Manually disabled accounts will not be automatically re-enabled by sync',
  'pages.tg.disabledFlowOptimizeTooltip':
    'Disabled by flow optimization after reaching today’s work-order threshold; can only be re-enabled manually',
  'pages.tg.disabledAutoTooltip':
    'Disabled by automatic rules and can be re-enabled manually',
  'pages.tg.setRemark': 'Set Remark',
  'pages.tg.batchLockTitle': 'Batch IP Lock Settings',
  'pages.tg.batchLockDesc': 'Select the services that should share the same IP deduplication group',
  'pages.tg.batchLockPlaceholder': 'Enter a group name (required)',
  'pages.tg.selectedServices': '{count} services selected',
  'pages.tg.exportSuccess': 'Export successful',
  'pages.tg.pageRange': '{start}-{end} / {total}',
  'pages.tg.batchDedupeRequired': 'Please select at least one service',
  'pages.tg.batchDedupeSuccess': 'Successfully updated {count} services',
  'pages.tg.unbindBatchLockConfirmTitle':
    'Unbind this service from the current deduplication group?',
  'pages.tg.unbindBatchLockConfirmDesc':
    'After unbinding, this service will no longer belong to this batch deduplication group.',
  'pages.tg.unbindBatchLockConfirmOk': 'Unbind',
  'pages.tg.unbindBatchLockSuccess':
    'Batch deduplication binding has been removed',
  'pages.tg.deviceRouting': 'Device Routing',
  'pages.tg.deviceRoutingTitle': 'Device Routing - {name}',
  'pages.tg.deviceRoutingSave': 'Save',
  'pages.tg.deviceRoutingSaveSuccess': 'Device routing saved',
  'pages.tg.deviceRoutingSaveError': 'Failed to save device routing',
  'pages.tg.deviceRoutingNoLinks': 'No links available for this service',
  'pages.tg.deviceRoutingLink': 'Link',
  'pages.tg.deviceRoutingTagAll': 'All Devices',
  'pages.tg.deviceRoutingTagIOS': 'iOS Only',
  'pages.tg.deviceRoutingTagAndroid': 'Android Only',
  'pages.tg.requestFailed': 'Request failed',
  'pages.tg.maxDomains': 'No more than 5000 entries are allowed',
  'pages.tg.redirectType': 'Redirect Type',
  'pages.tg.urlMode': 'Redirect Entry',
  'pages.tg.redirectTypeRequired': 'Please select a redirect type',
  'pages.tg.redirectTypePlaceholder': 'Please select a redirect type',
  'pages.tg.redirectLink': 'Link',
  'pages.tg.redirectId': 'ID',
  'pages.tg.accessRuleRequired': 'Please select an access rule',
  'pages.tg.accessRulePlaceholder': 'Please select an access rule',
  'pages.tg.accessRuleOrder': 'Sequential routing',
  'pages.tg.accessRuleRandom': 'Random routing',
  'pages.tg.domainsLabel': 'Telegram Link',
  'pages.tg.usernameLabel': 'Telegram ID',
  'pages.tg.domainsRequired': 'Please enter at least one Telegram Link',
  'pages.tg.usernameRequired': 'Please enter at least one Telegram ID',
  'pages.tg.configured': 'Configured {count} items',
  'pages.tg.usernamePlaceholder':
    'One Telegram ID per line, for example: username1\\nusername2\\nusername3',
  'pages.tg.domainsPlaceholder':
    'One Telegram Link per line, for example:\\nhttps://t.me/username1\\nhttps://t.me/username2',
  'pages.tg.usernameInvalid':
    'Invalid Telegram ID format (5-32 letters, numbers, underscores, optional leading +): {value}',
  'pages.tg.domainsInvalid':
    'Invalid link format, only official Telegram domains are allowed: {value}',

  // WhatsApp pages
  'pages.whatsapp.title': 'WhatsApp Service Management',
  'pages.whatsapp.subtitle':
    'Manage WhatsApp overseas distribution services with multiple links and access rules',
  'pages.whatsapp.addLink': 'Add Service',
  'pages.whatsapp.importPhone': 'Import Numbers',
  'pages.whatsapp.importPhoneTitle': 'Import Numbers',
  'pages.whatsapp.importPhoneConfirm': 'Import',
  'pages.whatsapp.importPhoneUploadText': 'Select or drop a TXT file',
  'pages.whatsapp.importPhoneUploadHint':
    'Format: number space remark, one per line. Numbers may include + and one or more spaces are supported; the raw file is parsed locally and is not uploaded.',
  'pages.whatsapp.importPhoneFileRequired': 'Please select a TXT file first',
  'pages.whatsapp.importPhoneFileTypeError': 'Only .txt text files can be imported',
  'pages.whatsapp.importPhoneFileSizeError': 'File size must not exceed 512KB',
  'pages.whatsapp.importPhoneInvalidLines':
    'Invalid import format. Please check line(s): {lines}',
  'pages.whatsapp.importPhoneNoValidRows': 'No valid phone numbers found',
  'pages.whatsapp.importPhoneTooManyRows': 'You can import at most {count} numbers at once',
  'pages.whatsapp.importPhoneSuccess':
    'Imported {count} numbers and created a service; skipped {duplicate} duplicates',
  'pages.whatsapp.importPhoneError': 'Import failed',
  'pages.whatsapp.importPhoneServiceNamePrefix': 'Imported Numbers',
  'pages.whatsapp.refresh': 'Refresh',
  'pages.whatsapp.export': 'Export',
  'pages.whatsapp.name': 'Name',
  'pages.whatsapp.configured': 'Configured',
  'pages.whatsapp.rule': 'Rule',
  'pages.whatsapp.ruleOrder': 'Order',
  'pages.whatsapp.ruleRandom': 'Random',
  'pages.whatsapp.rulePriority': 'Priority',
  'pages.whatsapp.lockIP': 'Lock IP',
  'pages.whatsapp.locked': 'Locked',
  'pages.whatsapp.unlocked': 'Unlocked',
  'pages.whatsapp.status': 'Status',
  'pages.whatsapp.enabled': 'Enabled',
  'pages.whatsapp.disabled': 'Disabled',
  'pages.whatsapp.createdAt': 'Created At',
  'pages.whatsapp.actions': 'Actions',
  'pages.whatsapp.copy': 'Copy',
  'pages.whatsapp.copySuccess': 'Link copied to clipboard',
  'pages.whatsapp.copyError': 'Copy failed',
  'pages.whatsapp.edit': 'Edit',
  'pages.whatsapp.delete': 'Delete',
  'pages.whatsapp.deleteConfirm': 'Are you sure you want to delete this service?',
  'pages.whatsapp.yes': 'Yes',
  'pages.whatsapp.no': 'No',
  'pages.whatsapp.addTitle': 'Add Service',
  'pages.whatsapp.editTitle': 'Edit Service',
  'pages.whatsapp.serviceName': 'Service Name',
  'pages.whatsapp.quantity': 'Quantity',
  'pages.whatsapp.serviceNamePlaceholder': 'Please enter service name',
  'pages.whatsapp.serviceNameRequired': 'Please enter service name',
  'pages.whatsapp.domains': 'Customer Link',
  'pages.whatsapp.domainsPlaceholder':
    'One per line, multiple entries separated by line breaks',
  'pages.whatsapp.domainsRequired': 'Please enter at least one customer link',
  'pages.whatsapp.domainsInvalid':
    'Invalid link format, only official WhatsApp domains are allowed',
  'pages.whatsapp.domainsInvalidDetailed':
    'Invalid link format, only official WhatsApp domains or wa.me links are allowed: {value}',
  'pages.whatsapp.deleteAccounts': 'Delete Accounts',
  'pages.whatsapp.deleteAccountsPlaceholder': 'Enter links/accounts to delete',
  'pages.whatsapp.deleteAccountsExtra':
    'Fill in links/accounts that need to be deleted',
  'pages.whatsapp.deleteAccountsRemoved': 'Removed {count} accounts',
  'pages.whatsapp.configuredCount': 'Configured',
  'pages.whatsapp.configuredLinks': 'contacts',
  'pages.whatsapp.accessRule': 'Access Rule',
  'pages.whatsapp.accessRulePlaceholder': 'Please select an access rule',
  'pages.whatsapp.accessRuleRequired': 'Please select an access rule',
  'pages.whatsapp.accessRuleOrder': 'Order - Access in sequence',
  'pages.whatsapp.accessRuleRandom': 'Random - Random selection',
  'pages.whatsapp.fetchSuccess': 'Service list fetched successfully',
  'pages.whatsapp.fetchError': 'Failed to fetch service list',
  'pages.whatsapp.deleteSuccess': 'Deleted successfully',
  'pages.whatsapp.deleteError': 'Failed to delete',
  'pages.whatsapp.updateSuccess': 'Updated successfully',
  'pages.whatsapp.updateError': 'Failed to update',
  'pages.whatsapp.addSuccess': 'Created successfully',
  'pages.whatsapp.addError': 'Failed to create',
  'pages.whatsapp.exportDev': 'Export function is under development...',
  'pages.whatsapp.totalRecords': 'Total {total} records',
  'pages.whatsapp.duplicateRemoved':
    'Automatically removed {count} duplicate entries',
  'pages.whatsapp.unknownError': 'Unknown error',
  'pages.whatsapp.operationFailed': 'Operation failed',
  'pages.whatsapp.trafficDataSuccess': 'Traffic data loaded successfully',
  'pages.whatsapp.trafficDataError': 'Failed to load traffic data',
  'pages.whatsapp.resetConfirmTitle': 'Confirm reset',
  'pages.whatsapp.resetConfirmLine1': 'This action cannot be undone:',
  'pages.whatsapp.resetConfirmLine2':
    'Are you sure you want to clear the visit records?',
  'pages.whatsapp.resetButton': 'Reset Data',
  'pages.whatsapp.resetSuccess': 'Statistics data has been fully cleared',
  'pages.whatsapp.dailyUV': 'Today UV/Yesterday UV',
  'pages.whatsapp.dailyUVTooltip': 'Unique visitors today / yesterday',
  'pages.whatsapp.workOrderIncrease': 'Today/Total Added',
  'pages.whatsapp.batchLock': 'Batch Lock',
  'pages.whatsapp.unset': 'Unset',
  'pages.whatsapp.stats': 'Visit Stats',
  'pages.whatsapp.trafficData': 'Traffic Data',
  'pages.whatsapp.interceptionConfig': 'Interception Config',
  'pages.whatsapp.generateQr': 'Generate QR Code',
  'pages.whatsapp.exportIp': 'Export IP',
  'pages.whatsapp.recreateShortLink':
    'Please recreate the service to generate a short link',
  'pages.whatsapp.copyCampaignLink': 'Copy Campaign Link',
  'pages.whatsapp.moreActions': 'More Actions',
  'pages.whatsapp.shareService': 'Share Service',
  'pages.whatsapp.fbIOSFix': 'FB Open Fix',
  'pages.whatsapp.fbIOSFixTitle': 'FB Open Fix - {name}',
  'pages.whatsapp.fbIOSFixReason':
    'Some iPhone users clicking WhatsApp links inside the Facebook in-app browser may be blocked from opening the external app and may see an incorrect not-installed prompt.',
  'pages.whatsapp.fbIOSFixScope':
    'When enabled, only iPhone + Facebook in-app browser + WhatsApp redirects will show an intermediate page. Other browsers and Android keep the normal redirect flow.',
  'pages.whatsapp.fbIOSFixNotice': 'Landing page buttons and diversion mode do not need this feature enabled.',
  'pages.whatsapp.fbIOSFixEnableLabel': 'Enable FB iOS open fix',
  'pages.whatsapp.fbIOSFixEnableSuccess': 'FB iOS open fix enabled',
  'pages.whatsapp.fbIOSFixDisableSuccess': 'FB iOS open fix disabled',
  'pages.whatsapp.fbIOSFixUpdateError': 'Failed to save FB iOS open fix',
  'pages.whatsapp.favorite': 'Favorite',
  'pages.whatsapp.unfavorite': 'Unfavorite',
  'pages.whatsapp.favoriteOnly': 'Favorites Only',
  'pages.whatsapp.favoriteSuccess': 'Added to favorites',
  'pages.whatsapp.unfavoriteSuccess': 'Removed from favorites',
  'pages.whatsapp.favoriteToggleFailed': 'Failed to update favorite',
  'pages.whatsapp.searchPlaceholder': 'Search name, code, account, link, or remark',
  'pages.whatsapp.workOrderManagement': 'Work Order Management',
  'pages.whatsapp.viewAll': 'View All',
  'pages.whatsapp.workOrderOnly': 'Work Orders Only',
  'pages.whatsapp.batchDedupe': 'Batch Deduplication',
  'pages.whatsapp.myIpLibrary': 'My IP Library',
  'pages.whatsapp.lockIPTooltip':
    'When enabled, browser fingerprint plus IP deduplication ensures the same visitor sees only one routed contact',
  'pages.whatsapp.trafficStatsTitle': 'Traffic Data Stats - {name}',
  'pages.whatsapp.close': 'Close',
  'pages.whatsapp.refreshData': 'Refresh Data',
  'pages.whatsapp.showingRecords': 'Showing {filtered} / {total} records',
  'pages.whatsapp.customerLink': 'Customer Link',
  'pages.whatsapp.workOrderIds': 'Bound',
  'pages.whatsapp.percentage': 'Percentage%',
  'pages.whatsapp.disabledManual': 'Disabled (Manual)',
  'pages.whatsapp.disabledFlowOptimize': 'Disabled (Flow Optimized)',
  'pages.whatsapp.disabledAuto': 'Disabled (Automatic)',
  'pages.whatsapp.disabledManualTooltip':
    'Manually disabled accounts will not be automatically re-enabled by sync',
  'pages.whatsapp.disabledFlowOptimizeTooltip':
    'Disabled by flow optimization after reaching today’s work-order threshold; can only be re-enabled manually',
  'pages.whatsapp.disabledAutoTooltip':
    'Disabled by automatic rules and can be re-enabled manually',
  'pages.whatsapp.remarkTitle': 'Set Remark',
  'pages.whatsapp.remarkPlaceholder': 'Enter a remark',
  'pages.whatsapp.remarkSuccess': 'Remark updated successfully',
  'pages.whatsapp.setRemark': 'Set Remark',
  'pages.whatsapp.pageRange': '{start}-{end} / {total}',
  'pages.whatsapp.exportSuccess': 'Export successful',
  'pages.whatsapp.batchLockTitle': 'Batch IP Lock Settings',
  'pages.whatsapp.batchLockDesc':
    'Select the services that should share the same IP deduplication group',
  'pages.whatsapp.batchLockPlaceholder': 'Enter a group name (required)',
  'pages.whatsapp.batchLockConfirm': 'Confirm',
  'pages.whatsapp.selectedServices': '{count} services selected',
  'pages.whatsapp.batchDedupeRequired':
    'Please select at least 2 services for deduplication',
  'pages.whatsapp.batchDedupeSuccess':
    'Assigned {count} services to the same deduplication group',
  'pages.whatsapp.batchDedupeError': 'Failed to update settings',
  'pages.whatsapp.unbindBatchLockConfirmTitle':
    'Unbind this service from the current deduplication group?',
  'pages.whatsapp.unbindBatchLockConfirmDesc':
    'After unbinding, this service will no longer belong to this batch deduplication group.',
  'pages.whatsapp.unbindBatchLockConfirmOk': 'Unbind',
  'pages.whatsapp.unbindBatchLockSuccess':
    'Batch deduplication binding has been removed',
  'pages.whatsapp.deviceRouting': 'Device Routing',
  'pages.whatsapp.deviceRoutingTitle': 'Device Routing - {name}',
  'pages.whatsapp.deviceRoutingSave': 'Save',
  'pages.whatsapp.deviceRoutingSaveSuccess': 'Device routing saved',
  'pages.whatsapp.deviceRoutingSaveError': 'Failed to save device routing',
  'pages.whatsapp.deviceRoutingNoLinks': 'No links available for this service',
  'pages.whatsapp.deviceRoutingLink': 'Link',
  'pages.whatsapp.deviceRoutingTagAll': 'All Devices',
  'pages.whatsapp.deviceRoutingTagIOS': 'iOS Only',
  'pages.whatsapp.deviceRoutingTagAndroid': 'Android Only',
  'pages.whatsapp.domainOrPhoneRequired':
    'Please enter at least one phone number or customer link',
  'pages.whatsapp.phoneLabel': 'Phone Number',
  'pages.whatsapp.phoneHint':
    'Enter country code and number without the plus sign',
  'pages.whatsapp.phoneRequired': 'Please enter at least one phone number',
  'pages.whatsapp.phoneInvalid':
    'Invalid phone number format, digits only: {value}',
  'pages.whatsapp.redirectType': 'Redirect Type',
  'pages.whatsapp.redirectTypeRequired': 'Please select a redirect type',
  'pages.whatsapp.redirectTypePlaceholder':
    'Please select a redirect type',
  'pages.whatsapp.redirectPhone': 'Phone Number',
  'pages.whatsapp.redirectLink': 'Link Redirect',
  'pages.whatsapp.greetingMode': 'Greeting Mode',
  'pages.whatsapp.greetingModeSingle': 'Single Greeting',
  'pages.whatsapp.greetingModeBatch': 'Batch Greetings',
  'pages.whatsapp.singleGreetingLabel': 'Single Greeting',
  'pages.whatsapp.singleGreetingExtra':
    'This greeting will be added automatically to the WhatsApp message',
  'pages.whatsapp.singleGreetingPlaceholder':
    'Enter a greeting, for example: Hi, I would like to ask about your service.',
  'pages.whatsapp.batchGreetingLabel': 'Batch Greetings',
  'pages.whatsapp.batchGreetingLimit': 'Up to {max} greetings; blank lines do not count.',
  'pages.whatsapp.batchGreetingCount': '{count} / {max} greetings',
  'pages.diversion.greetingLineLimit': 'Up to {max} lines; blank lines do not count.',
  'pages.diversion.greetingLineCount': '{count} / {max} lines',
  'pages.whatsapp.batchGreetingExtra':
    'One per line, the system will rotate through them automatically',
  'pages.whatsapp.batchGreetingPlaceholder':
    'Hi, I would like to ask about your service.\\nHow can you help me?\\nWelcome to contact us!',
  'pages.whatsapp.submitUpdate': 'Update',
  'pages.whatsapp.submitCreate': 'Create',
  'pages.whatsapp.cancel': 'Cancel',
  'pages.whatsapp.enableSuccess': 'Enabled successfully',
  'pages.whatsapp.disableSuccess': 'Disabled successfully',
  'pages.whatsapp.updateLinkTitle': 'Edit Link Content',
  'pages.whatsapp.linkOrPhone': 'Link or Phone Number',
  'pages.whatsapp.linkEmpty': 'Link or phone number cannot be empty',
  'pages.whatsapp.newLinkPlaceholder': 'Enter the new link or phone number',
  'pages.whatsapp.priorityRouting': 'Priority Routing',
  'pages.whatsapp.thresholdLabel': 'UV Threshold',
  'pages.whatsapp.thresholdTooltip':
    'The threshold is based on unique visitors and may fluctuate by 5%-20%.',
  'pages.whatsapp.thresholdRequired': 'Please enter the UV threshold',
  'pages.whatsapp.thresholdRange': 'Threshold must be between 1 and 10000',
  'pages.whatsapp.linkUpdateFailed': 'Failed to update link',
  'pages.whatsapp.editSuccess': 'Edited successfully',

  // Custom pages
  'pages.custom.title': 'Custom Routing Management',
  'pages.custom.subtitle':
    'Manage custom domain routing services with multiple links and access rules',
  'pages.custom.addService': 'Add Service',
  'pages.custom.refresh': 'Refresh',
  'pages.custom.interceptionConfig': 'Interception Config',
  'pages.custom.batchDedupe': 'Batch Deduplication',
  'pages.custom.searchPlaceholder': 'Search service name',
  'pages.custom.totalRecords': 'Total {total} records',
  'pages.custom.addTitle': 'Add Service',
  'pages.custom.editTitle': 'Edit Service',
  'pages.custom.serviceName': 'Service Name',
  'pages.custom.serviceNamePlaceholder': 'Please enter service name',
  'pages.custom.serviceNameRequired': 'Please enter service name',
  'pages.custom.serviceDescription': 'Service Description',
  'pages.custom.serviceDescriptionPlaceholder':
    'Please enter service description',
  'pages.custom.links': 'Links',
  'pages.custom.linksExtra':
    'One per line, multiple entries separated by line breaks, must start with https://',
  'pages.custom.domainsRequired': 'Please enter at least one link',
  'pages.custom.domainsInvalid':
    'Invalid link format, must start with https://: {value}',
  'pages.custom.accessRule': 'Access Rule',
  'pages.custom.accessRulePlaceholder': 'Please select an access rule',
  'pages.custom.accessRuleRequired': 'Please select an access rule',
  'pages.custom.accessRuleOrder': 'Order - Rotate in sequence',
  'pages.custom.accessRuleRandom': 'Random - Random selection',
  'pages.custom.statusSettings': 'Status Settings',
  'pages.custom.lockIP': 'Lock IP',
  'pages.custom.lockIPTooltip':
    'When enabled, browser fingerprint plus IP deduplication ensures the same visitor sees only one routed contact',
  'pages.custom.status': 'Status',
  'pages.custom.enabled': 'Enabled',
  'pages.custom.disabled': 'Disabled',
  'pages.custom.submitUpdate': 'Update',
  'pages.custom.submitCreate': 'Create',
  'pages.custom.cancel': 'Cancel',
  'pages.custom.loadError': 'Failed to load data',
  'pages.custom.requestFailed': 'Request failed',
  'pages.custom.updateSuccess': 'Updated successfully',
  'pages.custom.addSuccess': 'Created successfully',
  'pages.custom.updateError': 'Failed to update',
  'pages.custom.operationFailed': 'Operation failed',
  'pages.custom.deleteSuccess': 'Deleted successfully',
  'pages.custom.deleteError': 'Failed to delete',
  'pages.custom.shortCodeMissing':
    'Short code is missing, please recreate the service',
  'pages.custom.copySuccess': 'Short link copied to clipboard',
  'pages.custom.copyError': 'Copy failed',
  'pages.custom.trafficDataError': 'Failed to load traffic data',
  'pages.custom.enableSuccess': 'Enabled successfully',
  'pages.custom.disableSuccess': 'Disabled successfully',
  'pages.custom.remarkTitle': 'Set Remark',
  'pages.custom.remarkPlaceholder': 'Enter a remark',
  'pages.custom.remarkSuccess': 'Remark updated successfully',
  'pages.custom.updateLinkTitle': 'Edit Link Content',
  'pages.custom.currentContent': 'Current content',
  'pages.custom.newLinkPlaceholder': 'Enter the new link',
  'pages.custom.linkEmpty': 'Link cannot be empty',
  'pages.custom.linkUpdateSuccess': 'Link content updated successfully',
  'pages.custom.unknownError': 'Unknown error',
  'pages.custom.resetConfirmTitle': 'Confirm reset',
  'pages.custom.resetConfirmContent':
    'Resetting will clear today’s UV and PV data for all customer links. This action cannot be undone. Continue?',
  'pages.custom.resetButton': 'Confirm Reset',
  'pages.custom.resetSuccess': 'Statistics have been reset',
  'pages.custom.name': 'Name',
  'pages.custom.quantity': 'Quantity',
  'pages.custom.description': 'Description',
  'pages.custom.configured': 'Configured',
  'pages.custom.configuredLinks': '{count} links',
  'pages.custom.rule': 'Rule',
  'pages.custom.ruleOrder': 'Order',
  'pages.custom.ruleRandom': 'Random',
  'pages.custom.locked': 'Locked',
  'pages.custom.unlocked': 'Unlocked',
  'pages.custom.batchLock': 'Batch Lock',
  'pages.custom.unset': 'Unset',
  'pages.custom.createdAt': 'Created At',
  'pages.custom.actions': 'Actions',
  'pages.custom.stats': 'Visit Stats',
  'pages.custom.trafficData': 'Traffic Data',
  'pages.custom.generateQr': 'Generate QR Code',
  'pages.custom.edit': 'Edit',
  'pages.custom.delete': 'Delete',
  'pages.custom.deleteConfirm': 'Confirm Delete',
  'pages.custom.deleteConfirmContent':
    'Are you sure you want to delete this service?',
  'pages.custom.yes': 'Confirm',
  'pages.custom.recreateShortLink':
    'Please recreate the service to generate a short link',
  'pages.custom.copyCampaignLink': 'Copy Campaign Link',
  'pages.custom.moreActions': 'More Actions',
  'pages.custom.shareService': 'Share Service',
  'pages.custom.trafficStatsTitle': 'Traffic Data Stats - {name}',
  'pages.custom.close': 'Close',
  'pages.custom.refreshData': 'Refresh Data',
  'pages.custom.customerLink': 'Customer Link',
  'pages.custom.percentage': 'Percentage%',
  'pages.custom.setRemark': 'Set Remark',
  'pages.custom.pageRange': '{start}-{end} / {total}',
  'pages.custom.batchLockTitle': 'Batch IP Lock Settings',
  'pages.custom.batchLockDesc':
    'Select the services that should share the same IP deduplication group',
  'pages.custom.batchLockPlaceholder': 'Enter a group name (required)',
  'pages.custom.selectedServices': '{count} services selected',
  'pages.custom.batchDedupeRequired':
    'Please select at least one service',
  'pages.custom.batchDedupeSuccess':
    'Successfully updated {count} services',

  // Service management pages
  'pages.serviceManagement.title': 'Service Management',
  'pages.serviceManagement.subtitle':
    'View and manage routing data across all platforms in one place',
  'pages.serviceManagement.platformCustom': 'Custom Routing',
  'pages.serviceManagement.custom': 'Custom',
  'pages.serviceManagement.selectPlatform': 'Select Platform',
  'pages.serviceManagement.selectPlatformPlaceholder':
    'Please select a platform',
  'pages.serviceManagement.selectService': 'Select Service',
  'pages.serviceManagement.selectServicePlaceholder':
    'Please select a platform first',
  'pages.serviceManagement.actions': 'Actions',
  'pages.serviceManagement.refresh': 'Refresh',
  'pages.serviceManagement.autoRefresh': 'Auto Refresh',
  'pages.serviceManagement.autoRefreshEnabled':
    'Auto refresh enabled every {interval}',
  'pages.serviceManagement.autoRefreshSeconds': '{seconds} sec',
  'pages.serviceManagement.autoRefreshMinutes': '{minutes} min',
  'pages.serviceManagement.stopAutoRefresh': 'Stop Auto Refresh',
  'pages.serviceManagement.autoRefreshStopped': 'Auto refresh stopped',
  'pages.serviceManagement.resetStats': 'Reset Stats',
  'pages.serviceManagement.noServices': 'No services available on this platform',
  'pages.serviceManagement.loadServicesError': 'Failed to load service list',
  'pages.serviceManagement.loadDataSuccess': 'Data loaded successfully',
  'pages.serviceManagement.loadDataError': 'Failed to load data',
  'pages.serviceManagement.resetConfirmTitle': 'Confirm reset',
  'pages.serviceManagement.resetConfirmContent':
    'Resetting will clear today’s UV and PV data for all customer links. This action cannot be undone. Continue?',
  'pages.serviceManagement.resetButton': 'Confirm Reset',
  'pages.serviceManagement.resetSuccess': 'Statistics have been reset',
  'pages.serviceManagement.cancel': 'Cancel',
  'pages.serviceManagement.confirm': 'Confirm',
  'pages.serviceManagement.unbind': 'Unbind',
  'pages.serviceManagement.unbindConfirmTitle': 'Confirm unbind',
  'pages.serviceManagement.unbindConfirmContent':
    'Are you sure you want to unbind work order "{name}" from the current service?',
  'pages.serviceManagement.unbindSuccess': 'Unbound successfully',
  'pages.serviceManagement.unbindFailed': 'Failed to unbind',
  'pages.serviceManagement.updateError': 'Failed to update',
  'pages.serviceManagement.unknownError': 'Unknown error',
  'pages.serviceManagement.enableSuccess': 'Enabled successfully',
  'pages.serviceManagement.disableSuccess': 'Disabled successfully',
  'pages.serviceManagement.operationFailed': 'Operation failed',
  'pages.serviceManagement.priorityUpdateSuccess':
    'Priority updated successfully',
  'pages.serviceManagement.thresholdUpdateFailed':
    'Failed to update threshold',
  'pages.serviceManagement.remarkTitle': 'Set Remark',
  'pages.serviceManagement.remarkPlaceholder': 'Enter a remark',
  'pages.serviceManagement.remarkSuccess': 'Remark updated successfully',
  'pages.serviceManagement.setTargetTitle': 'Set Target',
  'pages.serviceManagement.targetPlaceholder':
    'Enter target value (0 means unset)',
  'pages.serviceManagement.targetHint':
    'Note: This setting is valid for 24 hours and must be reset after expiration.',
  'pages.serviceManagement.targetSuccess': 'Target updated successfully',
  'pages.serviceManagement.updateLinkTitle': 'Edit Link Content',
  'pages.serviceManagement.currentContent': 'Current content',
  'pages.serviceManagement.newLinkPlaceholder': 'Enter the new link or ID',
  'pages.serviceManagement.linkEmpty': 'Link or ID cannot be empty',
  'pages.serviceManagement.linkUpdateSuccess':
    'Link content updated successfully',
  'pages.serviceManagement.boundWorkOrders': 'Bound Work Orders',
  'pages.serviceManagement.trafficData': 'Traffic Data',
  'pages.serviceManagement.searchAccount': 'Search accounts',
  'pages.serviceManagement.totalUV': 'Total UV',
  'pages.serviceManagement.totalPV': 'Total PV',
  'pages.serviceManagement.linksCount': 'Links',
  'pages.serviceManagement.avgUV': 'Avg UV',
  'pages.serviceManagement.target': 'Target',
  'pages.serviceManagement.todayIncrease': 'Today Added',
  'pages.serviceManagement.totalIncrease': 'Total Added',
  'pages.serviceManagement.workOrderStats': 'Work Order Statistics',
  'pages.serviceManagement.emptyTitle':
    'Please select a platform and service first',
  'pages.serviceManagement.emptySubtitle':
    'After selection, routing data and statistics for the service will be shown here',
  'pages.serviceManagement.customerLink': 'Customer Link',
  'pages.serviceManagement.priority': 'Priority',
  'pages.serviceManagement.priorityHigh': 'Priority',
  'pages.serviceManagement.priorityNormal': 'Normal',
  'pages.serviceManagement.thresholdShort': 'UV Threshold',
  'pages.serviceManagement.priorityProgress': 'Priority Progress',
  'pages.serviceManagement.percentage': 'Percentage%',
  'pages.serviceManagement.status': 'Status',
  'pages.serviceManagement.enabled': 'Enabled',
  'pages.serviceManagement.disabled': 'Disabled',
  'pages.serviceManagement.disabledManual': 'Disabled (Manual)',
  'pages.serviceManagement.disabledFlowOptimize':
    'Disabled (Flow Optimized)',
  'pages.serviceManagement.disabledAuto': 'Disabled (Automatic)',
  'pages.serviceManagement.disabledManualTooltip':
    'Manually disabled accounts will not be automatically re-enabled by sync',
  'pages.serviceManagement.disabledFlowOptimizeTooltip':
    'Disabled by flow optimization after reaching today’s work-order threshold; can only be re-enabled manually',
  'pages.serviceManagement.disabledAutoTooltip':
    'Disabled by automatic rules and can be re-enabled manually',
  'pages.serviceManagement.remark': 'Remark',
  'pages.serviceManagement.setRemark': 'Set Remark',
  'pages.serviceManagement.edit': 'Edit',
  'pages.serviceManagement.receptionSettings': 'Reception Settings',
  'pages.serviceManagement.receptionLimit': 'Inbound Limit',
  'pages.serviceManagement.receptionUnlimited': 'Unlimited',
  'pages.serviceManagement.receptionCurrentTotal': 'Work Order Inbound Total',
  'pages.serviceManagement.receptionLimitHint':
    'The account is automatically disabled when the bound work order’s cumulative inbound count reaches this limit. Saving does not reset the count. Set 0 for unlimited. If the limit is already reached, saving disables the account immediately.',
  'pages.serviceManagement.receptionEnableHint':
    'Increasing or removing the limit does not enable the account automatically. Enable it manually when ready.',
  'pages.serviceManagement.receptionNoWorkOrder':
    'This account has no bound work order. You can save now; the limit takes effect after binding and syncing a work order.',
  'pages.serviceManagement.receptionLimitInvalid': 'Enter an integer from 0 to 2147483647',
  'pages.serviceManagement.receptionLimitBelowCurrentTotal': 'The limit is less than the current inbound total!',
  'pages.serviceManagement.receptionSave': 'Save',
  'pages.serviceManagement.receptionSaveSuccess': 'Reception settings saved',
  'pages.serviceManagement.receptionLoadError': 'Failed to load reception settings',
  'pages.serviceManagement.disabledReception': 'Reception Full',
  'pages.serviceManagement.disabledReceptionTooltip':
    'Automatically disabled because the work order inbound total reached the reception limit. Increase or remove the limit before enabling it manually.',
  'pages.serviceManagement.pageRange': '{start}-{end} / {total}',
  'pages.serviceManagement.workOrderLoadError':
    'Failed to load work order list',
  'pages.serviceManagement.workOrderStatusActive': 'Active',
  'pages.serviceManagement.workOrderStatusPaused': 'Paused',
  'pages.serviceManagement.workOrderStatusError': 'Error',
  'pages.serviceManagement.workOrderName': 'Work Order Name',
  'pages.serviceManagement.platformType': 'Platform Type',
  'pages.serviceManagement.workOrderPlatform': 'Work Order Platform',
  'pages.serviceManagement.totalAccounts': 'Total Accounts',
  'pages.serviceManagement.availableCount': 'Available',
  'pages.serviceManagement.unavailableCount': 'Unavailable',
  'pages.serviceManagement.lastUpdatedAt': 'Last Updated',
  'pages.serviceManagement.workOrderStatus': 'Work Order Status',
  'pages.serviceManagement.noBoundWorkOrders': 'No bound work orders',
  'pages.serviceManagement.totalRecords': 'Total {total}',

  // Stats pages
  'pages.stats.loadSuccess': 'Data loaded successfully',
  'pages.stats.loadError': 'Failed to load data',
  'pages.stats.date': 'Date',
  'pages.stats.visitTime': 'Visit Time',
  'pages.stats.customerLink': 'Customer Link',
  'pages.stats.region': 'Region',
  'pages.stats.device': 'Device',
  'pages.stats.system': 'System',
  'pages.stats.model': 'Model',
  'pages.stats.visitStats': 'Visit Stats',
  'pages.stats.today': 'Today',
  'pages.stats.sevenDays': '7 Days',
  'pages.stats.refresh': 'Refresh',
  'pages.stats.refreshData': 'Refresh Data',
  'pages.stats.close': 'Close',
  'pages.stats.syncLoading': 'Syncing and loading data...',
  'pages.stats.pageRange': '{start}-{end} / {total}',
  'pages.stats.linkSummary': 'Link Summary',
  'pages.stats.unknown': 'Unknown',
  'pages.stats.mobile': 'Mobile',
  'pages.stats.desktop': 'Desktop',
  'pages.stats.tablet': 'Tablet',

  // Domain copy
  'pages.domainCopy.copy': 'Copy',
  'pages.domainCopy.copySuccess': 'Copied successfully',
  'pages.domainCopy.copyFailed': 'Copy failed',
  'pages.domainCopy.publicDomain': 'Public Domain',
  'pages.domainCopy.customDomain': 'Custom Domain',
  'pages.domainCopy.remark': 'Remark',
  'pages.domainCopy.sslSuccess': 'SSL Ready',
  'pages.domainCopy.sslPending': 'Pending',
  'pages.domainCopy.sslFailed': 'SSL Failed',

  // Interception config modal
  'pages.interception.title': 'Interception Settings - {name}',
  'pages.interception.countryControl': 'Country Control',
  'pages.interception.countryControlExtra':
    'When enabled, only IPs from selected countries can access. IPs from other countries will be blocked.',
  'pages.interception.blockAll': 'Block All',
  'pages.interception.blockAllExtra':
    'When enabled, all visitors follow the interception display URL. Useful for temporarily sending TikTok Instant Page or ad review traffic to a review page.',
  'pages.interception.shareRefererBlock': 'Block Shared Links',
  'pages.interception.shareRefererBlockExtra':
    'Block visits opened from Android apps when the Referer starts with android-app://.',
  'pages.interception.enabled': 'On',
  'pages.interception.disabled': 'Off',
  'pages.interception.allowedCountries': 'Allowed Countries',
  'pages.interception.allowedCountriesRequired':
    'Please select at least one country',
  'pages.interception.allowedCountriesPlaceholder':
    'Please select allowed countries',
  'pages.interception.countryBlock': 'Blocked Countries',
  'pages.interception.countryBlockExtra':
    'Block IPs from selected countries. When Allowed Countries is enabled, the allow rule takes priority and this rule is skipped.',
  'pages.interception.blockedCountries': 'Countries to Block',
  'pages.interception.blockedCountriesRequired':
    'Please select at least one country to block',
  'pages.interception.blockedCountriesPlaceholder':
    'Please select countries to block',
  'pages.interception.chineseDetection': 'Chinese Detection',
  'pages.interception.chineseDetectionExtra':
    'Detect visitor browser language and intercept based on whether it is Chinese',
  'pages.interception.chineseDetectionMode': 'Chinese Detection Mode',
  'pages.interception.chineseDetectionModeRequired':
    'Please select a detection mode',
  'pages.interception.blockChinese': 'Block Chinese browsers',
  'pages.interception.onlyAllowChinese': 'Allow only Chinese browsers',
  'pages.interception.displayUrl': 'Interception Display URL',
  'pages.interception.displayUrlExtra':
    'Redirect to this URL when intercepted. Leave empty to return 404.',
  'pages.interception.displayUrlPlaceholder': 'https://example.com',
  'pages.interception.updateSuccess': 'Updated successfully',
  'pages.interception.saveSuccess': 'Saved successfully',
  'pages.interception.operationFailed': 'Operation failed',
  'pages.interception.linkedIpLibrary': 'Linked IP library: {name}',

  // Export IP modal
  'pages.exportIP.title': 'Export IPs',
  'pages.exportIP.confirm': 'Confirm',
  'pages.exportIP.cancel': 'Cancel',
  'pages.exportIP.exporting': 'Exporting, please wait...',
  'pages.exportIP.infoMessage':
    'This feature exports visitor IP data collected through the landing page',
  'pages.exportIP.timeRange': 'Time Range',
  'pages.exportIP.timeRangeRequired': 'Please select a time range',
  'pages.exportIP.today': 'Today',
  'pages.exportIP.last7Days': 'Last 7 Days',
  'pages.exportIP.exportType': 'Export Method',
  'pages.exportIP.exportText': 'Export to text',
  'pages.exportIP.exportLibrary': 'Export to my IP library',
  'pages.exportIP.action': 'Action',
  'pages.exportIP.actionNew': 'Add new (create library)',
  'pages.exportIP.actionMerge': 'Merge into existing library',
  'pages.exportIP.countryRemark': 'Country Remark',
  'pages.exportIP.countryRemarkRequired': 'Please enter a country remark',
  'pages.exportIP.countryRemarkPlaceholder': 'For example: USA, UK',
  'pages.exportIP.industryRemark': 'Industry Remark',
  'pages.exportIP.industryRemarkRequired': 'Please enter an industry remark',
  'pages.exportIP.industryRemarkPlaceholder':
    'For example: Ecommerce, Finance',
  'pages.exportIP.selectLibrary': 'Select IP Library',
  'pages.exportIP.selectLibraryRequired': 'Please select an IP library',
  'pages.exportIP.selectLibraryPlaceholder':
    'Please select the IP library to merge into',
  'pages.exportIP.libraryOption': '{country} - {industry} ({count} IPs)',
  'pages.exportIP.largeDataTitle': 'Large Data Volume',
  'pages.exportIP.largeDataContent':
    'You are about to export {count} IPs. This may take some time. Continue?',
  'pages.exportIP.continueExport': 'Continue Export',
  'pages.exportIP.successText': 'Export successful, total {count} IPs',
  'pages.exportIP.successLibrary':
    'Exported to IP library successfully, total {count} IPs',
  'pages.exportIP.failed': 'Export failed',

  // Work order
  'pages.workOrder.requestFailedRetry': 'Request failed, please try again',
  'pages.workOrder.unknownError': 'An unknown error occurred',
  'pages.workOrder.loadOrdersFailed': 'Failed to load work orders',
  'pages.workOrder.updateSuccess': 'Work order updated successfully',
  'pages.workOrder.createSuccess': 'Work order created successfully',
  'pages.workOrder.operationFailed': 'Operation failed',
  'pages.workOrder.deleteConfirmTitle': 'Confirm Deletion',
  'pages.workOrder.deleteConfirmContent':
    'Are you sure you want to delete this work order? This action cannot be undone.',
  'pages.workOrder.confirm': 'Confirm',
  'pages.workOrder.cancel': 'Cancel',
  'pages.workOrder.deleteSuccess': 'Deleted successfully',
  'pages.workOrder.deleteFailed': 'Delete failed',
  'pages.workOrder.fetchSuccessBase':
    'Fetch successful! Total accounts: {total}, Normal: {normal}, Abnormal: {abnormal}',
  'pages.workOrder.fetchSuccessPages': ', read {pages} pages',
  'pages.workOrder.fetchSuccessSample':
    '; Sample [Phone: {phone} Status: {status} Friends/Groups: {friend} Daily adds: {daily}]',
  'pages.workOrder.fetchFailed': 'Fetch failed',
  'pages.workOrder.resumeSuccess':
    'Work order resumed and failure count has been reset',
  'pages.workOrder.resumeFailed': 'Resume failed',
  'pages.workOrder.pauseSuccess': 'Work order paused',
  'pages.workOrder.pauseFailed': 'Pause failed',
  'pages.workOrder.platformParamInvalidFetchServices':
    'Platform parameter is missing or invalid, unable to load service list',
  'pages.workOrder.loadServicesWarning':
    'No available services under the current platform. Please create a service first.',
  'pages.workOrder.loadServicesFailed': 'Failed to load service list',
  'pages.workOrder.platformInvalidImport':
    'Work order platform information is missing or invalid, unable to import',
  'pages.workOrder.selectImportService':
    'Please select the service to import into',
  'pages.workOrder.importSuccessNew':
    'Import successful! The service has been created. Please refresh the distribution page to view it.',
  'pages.workOrder.importSuccessReplace':
    'Import successful! Accounts have been replaced in the existing service.',
  'pages.workOrder.importSuccessMerge':
    'Import successful! Accounts have been merged into the existing service.',
  'pages.workOrder.importFailed': 'Import failed',
  'pages.workOrder.platformMissingLoadServices':
    'Platform information is missing, unable to load service list',
  'pages.workOrder.loadCaptchaFailed': 'Failed to load captcha',
  'pages.workOrder.sessionExpired':
    'Login session has expired. Please refresh the captcha and try again.',
  'pages.workOrder.loginBindSuccess': 'Login bound successfully',
  'pages.workOrder.loginFailed': 'Login failed',
  'pages.workOrder.name': 'Work Order Name',
  'pages.workOrder.platformType': 'Platform Type',
  'pages.workOrder.orderPlatform': 'Work Order Platform',
  'pages.workOrder.accountCount': 'Accounts',
  'pages.workOrder.todayIncrease': 'Today Added',
  'pages.workOrder.totalIncrease': 'Total Added',
  'pages.workOrder.lastFetch': 'Last Fetch',
  'pages.workOrder.orderStatus': 'Work Order Status',
  'pages.workOrder.actions': 'Actions',
  'pages.workOrder.edit': 'Edit',
  'pages.workOrder.pause': 'Pause',
  'pages.workOrder.resume': 'Resume',
  'pages.workOrder.delete': 'Delete',
  'pages.workOrder.resumeRunning': 'Resume',
  'pages.workOrder.read': 'Fetch',
  'pages.workOrder.import': 'Import',
  'pages.workOrder.rebindLogin': 'Rebind Login',
  'pages.workOrder.loginBind': 'Bind Login',
  'pages.workOrder.more': 'More',
  'pages.workOrder.title': 'Work Order Management',
  'pages.workOrder.newOrder': 'New Work Order',
  'pages.workOrder.batchCreate': 'Batch Add',
  'pages.workOrder.totalRecords': 'Total {total}',
  'pages.workOrder.editTitle': 'Edit Work Order',
  'pages.workOrder.createTitle': 'New Work Order',
  'pages.workOrder.platformTypeRequired': 'Please select a platform type',
  'pages.workOrder.orderPlatformRequired':
    'Please select a work order platform',
  'pages.workOrder.rocketUrlNotice':
    'Note: Rocket work orders cannot use short URLs directly. Open the short URL in a browser first, then enter the final URL.',
  'pages.workOrder.a2cUrlNotice':
    'Enter an A2C share link (id) or share-list API link (shareCode). API links may include password. Resolve short links in a browser first.',
  'pages.workOrder.whatshubShortUrlNotice':
    'Enter a complete WhatsHub work order URL (/work-order-sharing with sid and workId), an /m/ share link, or an API link. Enter the sharing password when using an /m/ link.',
  'pages.workOrder.whatshubShortUrlInvalid':
    'Invalid address. Enter a complete WhatsHub work order URL (/work-order-sharing with sid and workId), an /m/ share link, or an API link.',
  'pages.workOrder.nameRequired': 'Please enter a work order name',
  'pages.workOrder.namePlaceholder': 'Please enter a work order name',
  'pages.workOrder.link': 'Work Order URL',
  'pages.workOrder.linkRequired': 'Please enter a work order URL',
  'pages.workOrder.cloudLinkInvalid':
    'Cloud-control URL must include /share/share/index.html?token=xxx',
  'pages.workOrder.linkPlaceholderDefault':
    'http://47.76.114.187:61932/share/share/index.html?token=...',
  'pages.workOrder.linkPlaceholder007':
    'Enter a 007 platform share URL, any format is accepted',
  'pages.workOrder.linkPlaceholderSihai':
    'Enter the Sihai Marketing login URL (default: https://v2sotua1.7xing168.com/agent/login.html)',
  'pages.workOrder.password': 'Password',
  'pages.workOrder.passwordPlaceholder007':
    'Optional. If entered, it will be used to log in to the 007 work order.',
  'pages.workOrder.passwordPlaceholderScrmChampion':
    'Optional. If entered, it will be used to log in to the SCRM Champion work order.',
  'pages.workOrder.passwordPlaceholderSalesmartly':
    'Optional. If entered, it will be used to log in to the SaleSmartly work order.',
  'pages.workOrder.passwordPlaceholderHaiwang':
    'Optional. If entered, it will be used to log in to the Haiwang work order.',
  'pages.workOrder.passwordPlaceholderCeoscrm':
    'Optional. If entered, it will be used to log in to the CEOSCRM work order.',
  'pages.workOrder.passwordPlaceholderUrl66':
    'Optional. If entered, it will be used to log in to the Rocket url66 work order.',
  'pages.workOrder.passwordPlaceholderQukazhen':
    'Optional. If entered, it will be used to log in to the Qukazhen work order.',
  'pages.workOrder.passwordPlaceholderChatknow':
    'Optional. If entered, it will be used to log in to the Chatknow work order.',
  'pages.workOrder.passwordPlaceholderWachat':
    'Optional. If entered, it will be used to log in to the WAchat work order.',
  'pages.workOrder.passwordPlaceholderXinghe':
    'Optional. If entered, it will be used to log in to the Xinghe Cloud Control work order.',
  'pages.workOrder.passwordPlaceholderA2c':
    'Optional if the API link includes password. A password entered here takes priority.',
  'pages.workOrder.passwordPlaceholderUrl99':
    'Optional. If entered, it will be used to log in to the Rocket work order.',
  'pages.workOrder.advancedSettings': 'Advanced Settings',
  'pages.common.expandSettings': 'Expand settings',
  'pages.common.collapseSettings': 'Collapse settings',
  'pages.workOrder.autoDisable':
    'Auto disable (filter abnormal accounts automatically to reduce wasted traffic)',
  'pages.workOrder.autoOptimize':
    'Auto optimize (disable accounts with traffic but no conversion to improve routing efficiency)',
  'pages.workOrder.minUv': 'Minimum UV',
  'pages.workOrder.minUvTooltip':
    'It is recommended to set this above 10 when ads just start, to avoid AI crawler traffic triggering disable rules.',
  'pages.workOrder.minUvRequired': 'Please enter the minimum UV',
  'pages.workOrder.minUvPlaceholder': 'Default 10',
  'pages.workOrder.flowOptimize':
    'Flow optimization (disable accounts automatically after reaching today’s add-friend threshold)',
  'pages.workOrder.todayAddThreshold': 'Today Add-Friend Threshold',
  'pages.workOrder.todayAddThresholdTooltip':
    'When the account reaches this threshold of friends added today, the system will mark it as "Disabled (Flow Optimized)" and it can only be enabled manually.',
  'pages.workOrder.todayAddThresholdRequired':
    'Please enter today’s add-friend threshold',
  'pages.workOrder.todayAddThresholdPlaceholder': 'For example: 10',
  'pages.workOrder.sihaiLoginTitle': 'Sihai Marketing Login Binding',
  'pages.workOrder.loginAndBind': 'Login and Bind',
  'pages.workOrder.username': 'Username',
  'pages.workOrder.usernameRequired': 'Please enter username',
  'pages.workOrder.usernamePlaceholder': 'Please enter username',
  'pages.workOrder.passwordRequired': 'Please enter password',
  'pages.workOrder.passwordInputPlaceholder': 'Please enter password',
  'pages.workOrder.captcha': 'Captcha',
  'pages.workOrder.captchaRequired': 'Please enter captcha',
  'pages.workOrder.captchaPlaceholder': 'Please enter captcha',
  'pages.workOrder.refresh': 'Refresh',
  'pages.workOrder.captchaAlt': 'Captcha',
  'pages.workOrder.captchaLoadFailed':
    'Failed to load captcha. Please click refresh.',
  'pages.workOrder.importTitle': 'Import Work Order Data',
  'pages.workOrder.importMethod': 'Import Method',
  'pages.workOrder.importMethodRequired': 'Please select an import method',
  'pages.workOrder.importModeNew': 'Create New Service',
  'pages.workOrder.importModeExisting': 'Import into Existing Link',
  'pages.workOrder.selectService': 'Select Service',
  'pages.workOrder.selectServiceRequired':
    'Please select the service to import into',
  'pages.workOrder.loading': 'Loading...',
  'pages.workOrder.selectServicePlaceholder': 'Please select a service',
  'pages.workOrder.noAvailableServices': 'No available services',
  'pages.workOrder.mergeMode': 'Import Mode',
  'pages.workOrder.mergeModeRequired': 'Please select an import mode',
  'pages.workOrder.mergeModeTooltip':
    'Merge: keep existing accounts and append new ones (multiple work orders can share one service). Replace: clear existing accounts and import new ones (switch work-order data).',
  'pages.workOrder.merge': 'Merge (append accounts)',
  'pages.workOrder.replace': 'Replace (clear and import)',
  'pages.workOrder.statusSessionBound': 'Session Bound',
  'pages.workOrder.statusSessionExpired': 'Session Expired',
  'pages.workOrder.statusSessionUnbound': 'Session Not Bound',
  'pages.workOrder.tooltipPaused': 'Work order is paused',
  'pages.workOrder.statusPaused': 'Paused',
  'pages.workOrder.statusPausedWithFailures': 'Paused (Failed {count} times)',
  'pages.workOrder.tooltipFetchError': 'Errors occurred during fetch',
  'pages.workOrder.statusRunning': 'Running',
  'pages.workOrder.statusRunningWithFailures':
    'Running (Failed {count} times)',
  'pages.workOrder.source.cloud': 'Cloud Control',
  'pages.workOrder.source.haiwang': 'Haiwang',
  'pages.workOrder.source.url99': 'Rocket',
  'pages.workOrder.source.url66': 'Rocket url66',
  'pages.workOrder.source.qukazhen': 'Qukazhen',
  'pages.workOrder.source.sihai': 'Sihai Marketing',
  'pages.workOrder.source.xinghe': 'Xinghe Cloud Control',
  'pages.workOrder.source.a2c': 'A2C Cloud Control',

  // Ad callback list
  'pages.adCallbackList.loadLandingPagesFailed':
    'Failed to load landing pages',
  'pages.adCallbackList.enabledSuccess': 'Enabled',
  'pages.adCallbackList.disabledSuccess': 'Disabled',
  'pages.adCallbackList.operationFailed': 'Operation failed',
  'pages.adCallbackList.deleteSuccess': 'Deleted successfully',
  'pages.adCallbackList.deleteFailed': 'Delete failed',
  'pages.adCallbackList.landingPageMissing':
    'Associated landing page not found',
  'pages.adCallbackList.loadLandingPageDetailFailed':
    'Failed to get landing page information',
  'pages.adCallbackList.domainConfigMissing':
    'Domain configuration is not loaded yet. Please try again later.',
  'pages.adCallbackList.copyLinkSuccess':
    'Campaign link has been copied to the clipboard',
  'pages.adCallbackList.unknownError': 'Unknown error',
  'pages.adCallbackList.configName': 'Config Name',
  'pages.adCallbackList.aiLandingPage': 'AI Landing Page',
  'pages.adCallbackList.landingPage': 'Landing Page',
  'pages.adCallbackList.unknownLandingPage': 'Unknown landing page',
  'pages.adCallbackList.eventConfig': 'Event Config',
  'pages.adCallbackList.callbackConfig': 'Callback Config',
  'pages.adCallbackList.dedup': 'Dedup',
  'pages.adCallbackList.on': 'On',
  'pages.adCallbackList.off': 'Off',
  'pages.adCallbackList.ratio': 'Ratio',
  'pages.adCallbackList.successFailed': 'Success/Failed',
  'pages.adCallbackList.status': 'Status',
  'pages.adCallbackList.actions': 'Actions',
  'pages.adCallbackList.copyCampaignLink': 'Copy Campaign Link',
  'pages.adCallbackList.editConfig': 'Edit Config',
  'pages.adCallbackList.viewStats': 'View Stats',
  'pages.adCallbackList.deleteConfig': 'Delete Config',
  'pages.adCallbackList.deleteConfirmTitle':
    'Are you sure you want to delete this config?',
  'pages.adCallbackList.deleteConfirmDescription':
    'This action cannot be undone, and related statistics will also be removed.',
  'pages.adCallbackList.deleteConfirmShort':
    'Are you sure you want to delete this config?',
  'pages.adCallbackList.confirm': 'Confirm',
  'pages.adCallbackList.cancel': 'Cancel',
  'pages.adCallbackList.batchDelete': 'Batch Delete ({count})',
  'pages.adCallbackList.cancelSelection': 'Clear selection',
  'pages.adCallbackList.confirmDelete': 'Delete',
  'pages.adCallbackList.batchDeleteConfirmTitle':
    'Delete the selected {count} callback configs?',
  'pages.adCallbackList.batchDeleteConfirmContent':
    'This action cannot be undone, and related statistics will also be removed.',
  'pages.adCallbackList.batchDeleteSuccess': 'Deleted {count} callback configs',
  'pages.adCallbackList.batchDeletePartial':
    'Deleted {success}; {failed} failed to delete',
  'pages.adCallbackList.batchDeleteFailed': 'Batch delete failed',
  'pages.adCallbackList.createConfig': 'Create Config',
  'pages.adCallbackList.searchConfigName': 'Search config name',
  'pages.adCallbackList.search': 'Search',
  'pages.adCallbackList.landingPageId': 'Landing Page ID',
  'pages.adCallbackList.eventType': 'Event Type',
  'pages.adCallbackList.createdAt': 'Created At',
  'pages.adCallbackList.todayClicks': 'Today Clicks',
  'pages.adCallbackList.stats': 'Stats',
  'pages.adCallbackList.usageGuide': 'Usage Guide',
  'pages.adCallbackList.googleGuideAlt': 'Google Ads config guide',
  'pages.adCallbackList.googleGuideText':
    'The screenshot below shows where to place Google Ads conversion code and a sample configuration.',
  'pages.adCallbackList.googleGuideImageNotice':
    'The current guide image is from the Chinese admin UI. The setup steps are the same in English mode.',
  'pages.adCallbackList.tiktokTitle': 'TikTok Callback Configs',
  'pages.adCallbackList.tiktokSubtitle':
    'Manage TikTok Events API callback configs for multi-channel campaigns',
  'pages.adCallbackList.tiktokHeaderTitle': 'TikTok Config List',
  'pages.adCallbackList.facebookTitle': 'Facebook Callback Configs',
  'pages.adCallbackList.facebookSubtitle':
    'Manage Facebook Conversion API callback configs for multi-channel campaigns',
  'pages.adCallbackList.facebookHeaderTitle': 'Facebook Config List',
  'pages.adCallbackList.bigoTitle': 'Bigo Callback Configs',
  'pages.adCallbackList.bigoHeaderTitle': 'Bigo Config List',
  'pages.adCallbackList.googleTitle': 'Google Conversion Tracking',
  'pages.adCallbackList.googleHeaderTitle': 'Google Config List',

  // Ad callback stats
  'pages.adCallbackStats.loadConfigFailed':
    'Failed to load config information',
  'pages.adCallbackStats.loadStatsFailed': 'Failed to load stats',
  'pages.adCallbackStats.exportSuccess': 'Export successful',
  'pages.adCallbackStats.exportFailed': 'Export failed',
  'pages.adCallbackStats.clearSuccess': 'Statistics data has been cleared',
  'pages.adCallbackStats.clearFailed': 'Failed to clear data',
  'pages.adCallbackStats.time': 'Time',
  'pages.adCallbackStats.event': 'Event',
  'pages.adCallbackStats.ipAddress': 'IP Address',
  'pages.adCallbackStats.pageUrl': 'Page URL',
  'pages.adCallbackStats.status': 'Status',
  'pages.adCallbackStats.success': 'Success',
  'pages.adCallbackStats.failed': 'Failed',
  'pages.adCallbackStats.loading': 'Loading...',
  'pages.adCallbackStats.subTitle':
    'Route Code: {routeCode} | Platform: {platform}',
  'pages.adCallbackStats.backToConfigs': 'Back to Configs',
  'pages.adCallbackStats.exportData': 'Export Data',
  'pages.adCallbackStats.resetData': 'Reset Data',
  'pages.adCallbackStats.refresh': 'Refresh',
  'pages.adCallbackStats.timeRange': 'Time Range:',
  'pages.adCallbackStats.totalEvents': 'Total Events',
  'pages.adCallbackStats.successEvents': 'Successful Events',
  'pages.adCallbackStats.failedEvents': 'Failed Events',
  'pages.adCallbackStats.successRate': 'Success Rate',
  'pages.adCallbackStats.eventBreakdown': 'Event Breakdown',
  'pages.adCallbackStats.detailData': 'Detailed Data',
  'pages.adCallbackStats.totalRecords': 'Total {total} records',
  'pages.adCallbackStats.tiktokTitle': 'TikTok Stats - {name}',
  'pages.adCallbackStats.facebookTitle': 'Facebook Stats - {name}',
  'pages.adCallbackStats.bigoTitle': 'Bigo Stats - {name}',
  'pages.adCallbackStats.googleTitle': 'Google Stats - {name}',
  'pages.adCallbackStats.googleSubtitle': 'Google Ads conversion tracking statistics',

  // Ad callback form
  'pages.adCallbackForm.loadLandingPagesFailed':
    'Failed to load landing pages',
  'pages.adCallbackForm.parseLandingPageFailed':
    'Failed to parse landing page components',
  'pages.adCallbackForm.loadLandingPageDetailFailed':
    'Failed to load landing page details',
  'pages.adCallbackForm.loadConfigFailed': 'Failed to load config',
  'pages.adCallbackForm.createSuccess': 'Created successfully',
  'pages.adCallbackForm.updateSuccess': 'Updated successfully',
  'pages.adCallbackForm.createFailed': 'Create failed',
  'pages.adCallbackForm.updateFailed': 'Update failed',
  'pages.adCallbackForm.operationFailed': 'Operation failed',
  'pages.adCallbackForm.submitFailed': 'Submit failed',
  'pages.adCallbackForm.back': 'Back',
  'pages.adCallbackForm.backToList': 'Back to List',
  'pages.adCallbackForm.cancel': 'Cancel',
  'pages.adCallbackForm.save': 'Save',
  'pages.adCallbackForm.create': 'Create',
  'pages.adCallbackForm.update': 'Update',
  'pages.adCallbackForm.basicConfig': 'Basic Config',
  'pages.adCallbackForm.callbackConfig': 'Callback Config',
  'pages.adCallbackForm.apiConfig': '{platform} API Config',
  'pages.adCallbackForm.configGuide': 'Configuration Guide',
  'pages.adCallbackForm.relatedLandingPage': 'Linked Landing Page',
  'pages.adCallbackForm.landingPage': 'Landing Page',
  'pages.adCallbackForm.landingPageRequired': 'Please select a landing page',
  'pages.adCallbackForm.landingPagePlaceholder':
    'Please select a landing page',
  'pages.adCallbackForm.configName': 'Config Name',
  'pages.adCallbackForm.configNameRequired': 'Please enter a config name',
  'pages.adCallbackForm.remark': 'Remark',
  'pages.adCallbackForm.remarkPlaceholder':
    'Optional. Use this to record the config purpose or channel info',
  'pages.adCallbackForm.optional': 'Optional',
  'pages.adCallbackForm.pixelId': 'Pixel ID',
  'pages.adCallbackForm.pixelIdRequired': 'Please enter Pixel ID',
  'pages.adCallbackForm.accessToken': 'Access Token',
  'pages.adCallbackForm.accessTokenRequired': 'Please enter Access Token',
  'pages.adCallbackForm.eventType': 'Event Type',
  'pages.adCallbackForm.eventTypeRequired': 'Please select an event type',
  'pages.adCallbackForm.eventTypePlaceholder':
    'Please select an event type',
  'pages.adCallbackForm.reportEvent': 'Report Event',
  'pages.adCallbackForm.defaultValue': 'Default Value',
  'pages.adCallbackForm.defaultValueRequired': 'Please enter a default value',
  'pages.adCallbackForm.defaultCurrency': 'Default Currency',
  'pages.adCallbackForm.defaultCurrencyRequired':
    'Please select a default currency',
  'pages.adCallbackForm.defaultCurrencyPlaceholder':
    'Please select a currency',
  'pages.adCallbackForm.dedupIp': 'IP Deduplication',
  'pages.adCallbackForm.enabledText': 'On',
  'pages.adCallbackForm.disabledText': 'Off',
  'pages.adCallbackForm.callbackRatio': 'Callback Ratio (%)',
  'pages.adCallbackForm.component': 'Component',
  'pages.adCallbackForm.selectComponent': 'Select component',
  'pages.adCallbackForm.unnamedComponent': 'Unnamed component',
  'pages.adCallbackForm.jumpUrl': 'Jump URL',
  'pages.adCallbackForm.enabled': 'Enabled',
  'pages.adCallbackForm.actions': 'Actions',
  'pages.adCallbackForm.delete': 'Delete',
  'pages.adCallbackForm.jumpRuleConfigOptional':
    'Jump Rule Configuration (Optional)',
  'pages.adCallbackForm.jumpRuleHintTitle': 'Jump Rule Description',
  'pages.adCallbackForm.jumpRuleHintDescription':
    'You can set dynamic jump URLs for buttons, images, and other components on the landing page, so different callback configs can reuse the same landing page. If not configured, the landing page default setting will be used.',
  'pages.adCallbackForm.selectLandingPageFirst':
    'Please select a landing page first',
  'pages.adCallbackForm.selectLandingPageFirstDescription':
    'After selecting a landing page, all available components on that page will be shown here so you can configure jump rules.',
  'pages.adCallbackForm.noAvailableComponents':
    'This landing page has no available components',
  'pages.adCallbackForm.noAvailableComponentsDescription':
    'There are no configurable jump components on this landing page, such as buttons or images.',
  'pages.adCallbackForm.addJumpRule': 'Add Jump Rule',
  'pages.adCallbackForm.component.floatingButton': 'Floating Button',
  'pages.adCallbackForm.component.floatingButtonLabel':
    'Floating Button: {text}',
  'pages.adCallbackForm.component.heroButton1Label':
    'Hero Button 1: {text}',
  'pages.adCallbackForm.component.heroButton2Label':
    'Hero Button 2: {text}',
  'pages.adCallbackForm.component.transparentIconLabel':
    'Transparent Icon: {text}',
  'pages.adCallbackForm.component.unnamed': 'Unnamed',
  'pages.adCallbackForm.component.styleModulePrefix': 'Style Module - ',
  'pages.adCallbackForm.component.buyButtonLabel': 'Buy Button: {text}',
  'pages.adCallbackForm.component.buyNow': 'Buy Now',
  'pages.adCallbackForm.component.ecommercePrefix': 'Product - ',
  'pages.adCallbackForm.component.countdownPrefix': 'Countdown - ',
  'pages.adCallbackForm.component.dialogPrefix': 'Dialog - ',
  'pages.adCallbackForm.component.formPrefix': 'Form - ',
  'pages.adCallbackForm.google.createTitle': 'Create Google Config',
  'pages.adCallbackForm.google.editTitle': 'Edit Google Config',
  'pages.adCallbackForm.google.configNamePlaceholder':
    'For example: WhatsApp conversion tracking',
  'pages.adCallbackForm.google.pixelCode': 'Pixel Code',
  'pages.adCallbackForm.google.pixelCodePlaceholder':
    'Paste Google pixel code here, including base tracking code such as Google Tag Manager or Google Analytics',
  'pages.adCallbackForm.google.eventCode': 'Event Code',
  'pages.adCallbackForm.google.eventCodePlaceholder':
    'Paste Google event code here, such as Google Ads conversion tracking code',
  'pages.adCallbackForm.bigo.createTitle': 'Create BigO Config',
  'pages.adCallbackForm.bigo.editTitle': 'Edit BigO Config',
  'pages.adCallbackForm.bigo.introTitle': 'BigO Callback Notes',
  'pages.adCallbackForm.bigo.introDescription':
    'Please fill in the Pixel ID and event type for the BigO ad platform. The bbg parameter will be read automatically from the URL.',
  'pages.adCallbackForm.bigo.configNamePlaceholder':
    'For example: US market - button click',
  'pages.adCallbackForm.bigo.pixelIdPlaceholder': 'BigO ad Pixel ID',
  'pages.adCallbackForm.bigo.event.button': 'button (Button Click)',
  'pages.adCallbackForm.bigo.event.consult': 'consult (Consultation)',
  'pages.adCallbackForm.bigo.event.ec_register':
    'ec_register (User Registration)',
  'pages.adCallbackForm.bigo.event.ec_add_cart':
    'ec_add_cart (Add to Cart)',
  'pages.adCallbackForm.bigo.event.ec_order': 'ec_order (Place Order)',
  'pages.adCallbackForm.bigo.event.ec_purchase':
    'ec_purchase (Payment Completed)',
  'pages.adCallbackForm.bigo.event.form': 'form (Form Submission)',
  'pages.adCallbackForm.bigo.event.phone_consult':
    'phone_consult (Phone Consultation)',
  'pages.adCallbackForm.bigo.event.app_download':
    'app_download (Download Click)',
  'pages.adCallbackForm.tiktok.createTitle': 'Create TikTok Config',
  'pages.adCallbackForm.tiktok.editTitle': 'Edit TikTok Config',
  'pages.adCallbackForm.tiktok.subtitle':
    'Configure TikTok Events API callback parameters and jump rules',
  'pages.adCallbackForm.tiktok.configNamePlaceholder':
    'For example: TikTok campaign config',
  'pages.adCallbackForm.tiktok.contentIdRule': 'Content ID Rule',
  'pages.adCallbackForm.tiktok.contentIdRuleTooltip':
    'This is the parameter submitted to TikTok when the callback is triggered. If unsure, keep the default setting.',
  'pages.adCallbackForm.tiktok.fixedContentId': 'Fixed Content ID',
  'pages.adCallbackForm.tiktok.fixedContentIdRequired':
    'Please enter the fixed Content ID',
  'pages.adCallbackForm.tiktok.fixedContentIdPlaceholder':
    'Fixed Content ID value',
  'pages.adCallbackForm.tiktok.guideTitle': 'TikTok API Configuration Guide',
  'pages.adCallbackForm.tiktok.guideDescription1':
    'Create a Pixel in the TikTok dashboard, choose TikTok API callback, then generate an access token and paste it into Access Token.',
  'pages.adCallbackForm.tiktok.guideDescription2':
    'Content ID Rule is the parameter submitted to TikTok when the callback is triggered. If unsure, keep the default setting.',
  'pages.adCallbackForm.tiktok.contentIdMode.pageId':
    'Use Landing Page ID',
  'pages.adCallbackForm.tiktok.contentIdMode.routeCode':
    'Use Route Code',
  'pages.adCallbackForm.tiktok.contentIdMode.fixed': 'Fixed Value',
  'pages.adCallbackForm.tiktok.event.clickButton':
    'ClickButton (Button Click)',
  'pages.adCallbackForm.tiktok.event.submitForm':
    'SubmitForm (Form Submission)',
  'pages.adCallbackForm.tiktok.event.contact': 'Contact (Contact)',
  'pages.adCallbackForm.tiktok.event.viewContent':
    'ViewContent (Page View)',
  'pages.adCallbackForm.tiktok.event.completeRegistration':
    'CompleteRegistration (Registration Completed)',
  'pages.adCallbackForm.tiktok.event.addToCart':
    'AddToCart (Add to Cart)',
  'pages.adCallbackForm.tiktok.event.addToWishlist':
    'AddToWishlist (Add to Wishlist)',
  'pages.adCallbackForm.tiktok.event.initiateCheckout':
    'InitiateCheckout (Start Checkout)',
  'pages.adCallbackForm.tiktok.event.addPaymentInfo':
    'AddPaymentInfo (Add Payment Info)',
  'pages.adCallbackForm.tiktok.event.placeAnOrder':
    'PlaceAnOrder (Place Order)',
  'pages.adCallbackForm.tiktok.event.completePayment':
    'CompletePayment (Complete Payment)',
  'pages.adCallbackForm.tiktok.event.purchase': 'Purchase (Purchase)',
  'pages.adCallbackForm.tiktok.event.lead': 'Lead (Potential Customer)',
  'pages.adCallbackForm.tiktok.event.applicationApproval':
    'ApplicationApproval (Application Approval)',
  'pages.adCallbackForm.tiktok.event.customizeProduct':
    'CustomizeProduct (Customize Product)',
  'pages.adCallbackForm.tiktok.event.download': 'Download (Download)',
  'pages.adCallbackForm.tiktok.event.findLocation':
    'FindLocation (Find Location)',
  'pages.adCallbackForm.tiktok.event.schedule': 'Schedule (Schedule)',
  'pages.adCallbackForm.tiktok.event.search': 'Search (Search)',
  'pages.adCallbackForm.tiktok.event.startTrial': 'StartTrial (Start Trial)',
  'pages.adCallbackForm.tiktok.event.submitApplication':
    'SubmitApplication (Submit Application)',
  'pages.adCallbackForm.tiktok.event.subscribe': 'Subscribe (Subscribe)',
  'pages.adCallbackForm.facebook.createTitle': 'Create Facebook Config',
  'pages.adCallbackForm.facebook.editTitle': 'Edit Facebook Config',
  'pages.adCallbackForm.facebook.subtitle':
    'Configure Facebook Conversion API callback parameters and jump rules',
  'pages.adCallbackForm.facebook.configNamePlaceholder':
    'For example: Facebook campaign config',
  'pages.adCallbackForm.facebook.configDescriptionTitle':
    'Configuration Notes',
  'pages.adCallbackForm.facebook.configDescriptionText':
    'Create a Pixel in Facebook Events Manager, choose server-side events, then generate an access token and paste it into Access Token.',
  'pages.adCallbackForm.facebook.testEventCode':
    'Test Event Code (Optional)',
  'pages.adCallbackForm.facebook.testEventCodeTooltip':
    'Used by the Facebook Event Testing Tool. Leave blank in production.',
  'pages.adCallbackForm.facebook.testEventCodePlaceholder':
    'Test event code',
  'pages.adCallbackForm.facebook.attributionShare':
    'Attribution Share',
  'pages.adCallbackForm.facebook.attributionShareTooltip':
    'The conversion attribution ratio. Keep the default unless you need a custom value.',
  'pages.adCallbackForm.facebook.guideTitle':
    'Facebook Conversion API Configuration Guide',
  'pages.adCallbackForm.facebook.guideDescription1':
    'Create a manual API in the Facebook dashboard, choose server API events, then generate an access token and paste it into Access Token.',
  'pages.adCallbackForm.facebook.guideDescription2':
    'Test Event Code is used by the Facebook Event Testing Tool. Do not fill in this field when officially activating events.',
  'pages.adCallbackForm.facebook.event.pageView': 'PageView (Page View)',
  'pages.adCallbackForm.facebook.event.viewContent':
    'ViewContent (View Content)',
  'pages.adCallbackForm.facebook.event.addToCart':
    'AddToCart (Add to Cart)',
  'pages.adCallbackForm.facebook.event.addToWishlist':
    'AddToWishlist (Add to Wishlist)',
  'pages.adCallbackForm.facebook.event.initiateCheckout':
    'InitiateCheckout (Start Checkout)',
  'pages.adCallbackForm.facebook.event.purchase': 'Purchase (Purchase)',
  'pages.adCallbackForm.facebook.event.lead': 'Lead (Potential Customer)',
  'pages.adCallbackForm.facebook.event.completeRegistration':
    'CompleteRegistration (Complete Registration)',
  'pages.adCallbackForm.facebook.event.contact': 'Contact (Contact)',
  'pages.adCallbackForm.facebook.event.customizeProduct':
    'CustomizeProduct (Customize Product)',
  'pages.adCallbackForm.facebook.event.submitApplication':
    'SubmitApplication (Submit Application)',
  'pages.adCallbackForm.facebook.event.startTrial':
    'StartTrial (Start Trial)',
  'pages.adCallbackForm.facebook.event.schedule': 'Schedule (Schedule)',
  'pages.adCallbackForm.facebook.event.subscribe': 'Subscribe (Subscribe)',
  'pages.adCallbackForm.facebook.event.custom': 'Custom (Custom Event)',

  // Membership alerts
  'pages.membershipAlert.loadUserInfoFailed': 'Failed to load user info',
  'pages.membershipAlert.expiringTitle': 'Membership Expiring Soon',
  'pages.membershipAlert.expiringToday':
    'Your membership expires today ({expiryDate}). Please renew in time to continue using the service.',
  'pages.membershipAlert.expiringInDays':
    'Your membership expires in {days} days ({expiryDate}). Please renew in time to continue using the service.',
  'pages.membershipAlert.lowUvTitle': 'Low UV Balance',
  'pages.membershipAlert.lowUvDescription':
    'Your current plan has fewer than 5,000 UV remaining. Please recharge to keep campaigns running normally. Low UV will not affect the traffic-splitting service.',

  // SuperH pages
  'pages.superH.loadTikTokConfigsFailed':
    'Failed to load TikTok configs. Please check your network and try again.',
  'pages.superH.loadConfigFailed':
    'Failed to load config details. Please return to the list and try again.',
  'pages.superH.loadDataFailed': 'Failed to load data. Please try again later.',
  'pages.superH.startSuccess': 'Started',
  'pages.superH.stopSuccess': 'Stopped',
  'pages.superH.operationFailed': 'Operation failed',
  'pages.superH.deleteSuccess': 'Deleted successfully',
  'pages.superH.deleteFailed': 'Delete failed',
  'pages.superH.collectSuccess':
    'Collection successful: added {collectedCount}, total {totalCount}',
  'pages.superH.collectFailed': 'Collection failed',
  'pages.superH.loadProgressFailed': 'Failed to load progress',
  'pages.superH.configId': 'Config ID: {id}',
  'pages.superH.name': 'Config Name',
  'pages.superH.sourceConfigs': 'Source Configs',
  'pages.superH.targetConfig': 'Target Config',
  'pages.superH.sendInterval': 'Send Interval',
  'pages.superH.sendIntervalSeconds': '{interval}s',
  'pages.superH.status': 'Status',
  'pages.superH.statusRunning': 'Running',
  'pages.superH.statusStopped': 'Stopped',
  'pages.superH.actions': 'Actions',
  'pages.superH.start': 'Start',
  'pages.superH.stop': 'Stop',
  'pages.superH.collectTtclid': 'Collect ttclid',
  'pages.superH.collect': 'Collect',
  'pages.superH.viewProgress': 'View Progress',
  'pages.superH.progress': 'Progress',
  'pages.superH.deleteConfig': 'Delete Config',
  'pages.superH.deleteConfirmTitle':
    'Are you sure you want to delete this config?',
  'pages.superH.deleteConfirmDescription':
    'This action cannot be undone, and related ttclid data will also be removed.',
  'pages.superH.confirm': 'Confirm',
  'pages.superH.cancel': 'Cancel',
  'pages.superH.title': 'Super Callback Configs',
  'pages.superH.subtitle':
    'Collect callback data from source configs and send it to the target config on a schedule',
  'pages.superH.createConfig': 'Create Config',
  'pages.superH.headerTitle': 'Super Callback Config List',
  'pages.superH.progressModalTitle': 'Execution Progress',
  'pages.superH.executionProgress': 'Execution Progress',
  'pages.superH.totalCount': 'Total',
  'pages.superH.executedCount': 'Executed',
  'pages.superH.remainingCount': 'Remaining',
  'pages.superH.lastExecuteTime': 'Last Execute Time',
  'pages.superH.refreshProgress': 'Refresh Progress',
  'pages.superH.editTitle': 'Edit Super Callback Config',
  'pages.superH.createTitle': 'Create Super Callback Config',
  'pages.superH.breadcrumbAdCallback': 'Ad Callback',
  'pages.superH.breadcrumbList': 'Super Callback Configs',
  'pages.superH.breadcrumbEdit': 'Edit Config',
  'pages.superH.breadcrumbCreate': 'Create Config',
  'pages.superH.back': 'Back',
  'pages.superH.loading': 'Loading...',
  'pages.superH.noTikTokConfigTitle': 'No TikTok Config Found',
  'pages.superH.noTikTokConfigDescription':
    'Please create at least one TikTok callback config before creating a Super Callback config.',
  'pages.superH.configName': 'Config Name',
  'pages.superH.configNameRequired': 'Please enter a config name',
  'pages.superH.configNamePlaceholder':
    'Give this Super Callback config a name',
  'pages.superH.remark': 'Remark',
  'pages.superH.remarkPlaceholder':
    'Optional. Enter remarks for this config',
  'pages.superH.sourceConfigsRequired':
    'Please select at least one source config',
  'pages.superH.sourceConfigsPlaceholder':
    'Select one or more TikTok configs as data sources',
  'pages.superH.targetConfigRequired': 'Please select a target config',
  'pages.superH.targetConfigConflict':
    'The target config cannot be the same as the source config',
  'pages.superH.targetConfigPlaceholder':
    'Select the target TikTok config to deliver to',
  'pages.superH.sendIntervalLabel': 'Send Interval (Seconds)',
  'pages.superH.sendIntervalRequired': 'Please enter the send interval',
  'pages.superH.sendIntervalTooltip':
    'Controls the reporting frequency for batch delivery. Range: 30-120 seconds.',
  'pages.superH.sendIntervalPlaceholder': 'Default 60 seconds',
  'pages.superH.saveChanges': 'Save Changes',

  // External callback pages
  'pages.externalCallback.enabledSuccess': 'Enabled',
  'pages.externalCallback.disabledSuccess': 'Disabled',
  'pages.externalCallback.operationFailed': 'Operation failed',
  'pages.externalCallback.deleteSuccess': 'Deleted successfully',
  'pages.externalCallback.deleteFailed': 'Delete failed',
  'pages.externalCallback.id': 'ID',
  'pages.externalCallback.name': 'Config Name',
  'pages.externalCallback.platform': 'Platform',
  'pages.externalCallback.pixelId': 'Pixel ID',
  'pages.externalCallback.directAccess': 'Direct Install',
  'pages.externalCallback.configId': 'Config ID',
  'pages.externalCallback.copyDirectCode': 'Copy Direct Code',
  'pages.externalCallback.copySuccess': 'Copied',
  'pages.externalCallback.copyFailed': 'Copy failed',
  'pages.externalCallback.eventType': 'Event Type',
  'pages.externalCallback.callbackRatio': 'Callback Ratio',
  'pages.externalCallback.ipDedup': 'IP Deduplication',
  'pages.externalCallback.noDedup': 'No Deduplication',
  'pages.externalCallback.dedupHours': '{hours}h',
  'pages.externalCallback.createdAt': 'Created At',
  'pages.externalCallback.status': 'Status',
  'pages.externalCallback.actions': 'Actions',
  'pages.externalCallback.on': 'On',
  'pages.externalCallback.off': 'Off',
  'pages.externalCallback.stats': 'Stats',
  'pages.externalCallback.editConfig': 'Edit Config',
  'pages.externalCallback.deleteConfig': 'Delete Config',
  'pages.externalCallback.deleteConfirmTitle':
    'Are you sure you want to delete this config?',
  'pages.externalCallback.deleteConfirmDescription':
    'This action cannot be undone.',
  'pages.externalCallback.confirm': 'Confirm',
  'pages.externalCallback.cancel': 'Cancel',
  'pages.externalCallback.title': 'External URL Callback Configs',
  'pages.externalCallback.domainConfig': 'Domain Config',
  'pages.externalCallback.createConfig': 'Create Config',
  'pages.externalCallback.headerTitle': 'External Callback Config List',
  'pages.externalCallback.searchConfigName': 'Search config name',
  'pages.externalCallback.search': 'Search',
  'pages.externalCallback.loadConfigFailed': 'Failed to load config',
  'pages.externalCallback.updateSuccess': 'Updated successfully',
  'pages.externalCallback.createSuccess': 'Created successfully',
  'pages.externalCallback.submitFailed': 'Submit failed',
  'pages.externalCallback.editTitle': 'Edit External Callback Config',
  'pages.externalCallback.createTitle': 'Create External Callback Config',
  'pages.externalCallback.back': 'Back',
  'pages.externalCallback.save': 'Save',
  'pages.externalCallback.introTitle': 'External URL Callback Notes',
  'pages.externalCallback.introDescription':
    'This config is used for the external URL cloak flow. Customers use their own external landing pages and call the callback API through the JS SDK. The system then automatically sends the callback to the selected ad platform.',
  'pages.externalCallback.configName': 'Config Name',
  'pages.externalCallback.configNameRequired':
    'Please enter a config name',
  'pages.externalCallback.configNamePlaceholder':
    'For example: TikTok - US market',
  'pages.externalCallback.remark': 'Remark',
  'pages.externalCallback.remarkPlaceholder':
    'Config description (optional)',
  'pages.externalCallback.platformRequired':
    'Please select an ad platform',
  'pages.externalCallback.platformPlaceholder':
    'Please select an ad platform',
  'pages.externalCallback.pixelIdRequired': 'Please enter Pixel ID',
  'pages.externalCallback.pixelIdPlaceholder': 'The ad platform Pixel ID',
  'pages.externalCallback.accessToken': 'Access Token',
  'pages.externalCallback.accessTokenRequired':
    'Please enter Access Token',
  'pages.externalCallback.accessTokenPlaceholder':
    'The ad platform access token',
  'pages.externalCallback.eventTypeRequired':
    'Please select an event type',
  'pages.externalCallback.eventTypePlaceholder':
    'Please select an event type',
  'pages.externalCallback.selectPlatformFirst':
    'Please select an ad platform first',
  'pages.externalCallback.clientCustomEvent': 'Event passed by customer code',
  'pages.externalCallback.callbackRatioRequired':
    'Please set the callback ratio',
  'pages.externalCallback.callbackRatioHelp':
    'Set the callback percentage. 100 means always callback, 50 means a 50% callback probability, and 0 means no callback.',
  'pages.externalCallback.defaultValue': 'Default Value',
  'pages.externalCallback.defaultValueRequired':
    'Please enter the default value',
  'pages.externalCallback.defaultValueHelp':
    'This default value is used when the JS SDK call does not provide an amount.',
  'pages.externalCallback.defaultCurrency': 'Default Currency',
  'pages.externalCallback.defaultCurrencyRequired':
    'Please select a default currency',
  'pages.externalCallback.defaultCurrencyPlaceholder':
    'Please select a currency',
  'pages.externalCallback.enableDedup': 'IP Deduplication',
  'pages.externalCallback.statsTitle': 'Callback Stats - {name}',
  'pages.externalCallback.backToList': 'Back to List',
  'pages.externalCallback.loadConfigInfoFailed':
    'Failed to load config information',
  'pages.externalCallback.loadStatsFailed': 'Failed to load stats',
  'pages.externalCallback.event': 'Event',
  'pages.externalCallback.success': 'Success',
  'pages.externalCallback.failed': 'Failed',
  'pages.externalCallback.ip': 'IP',
  'pages.externalCallback.requestId': 'Request ID',
  'pages.externalCallback.time': 'Time',
  'pages.externalCallback.totalCallbacks': 'Total Callbacks',
  'pages.externalCallback.successCount': 'Success Count',
  'pages.externalCallback.failedCount': 'Failed Count',
  'pages.externalCallback.successRate': 'Success Rate',
  'pages.externalCallback.dateRange': 'Date Range:',
  'pages.externalCallback.query': 'Query',
  'pages.externalCallback.totalRecords': 'Total {total} records',

  // Landing page list
  'pages.landingPageList.loadDomainsFailed':
    'Failed to load domain configuration',
  'pages.landingPageList.accessCodeMissing': 'Access code does not exist',
  'pages.landingPageList.domainConfigMissing':
    'Domain configuration is not loaded yet. Please try again later.',
  'pages.landingPageList.linkCopied': 'Link copied to clipboard!',
  'pages.landingPageList.unknownError': 'Unknown error',
  'pages.landingPageList.copyLinkFailed': 'Copy failed: {message}',
  'pages.landingPageList.copySuccess': 'Copied successfully!',
  'pages.landingPageList.copyFailed': 'Copy failed: {message}',
  'pages.landingPageList.copyFailedShort': 'Copy failed',
  'pages.landingPageList.deleteSuccess': 'Deleted successfully!',
  'pages.landingPageList.deleteFailed': 'Delete failed: {message}',
  'pages.landingPageList.deleteFailedShort': 'Delete failed',
  'pages.landingPageList.batchDelete': 'Batch Delete',
  'pages.landingPageList.batchDeleteWithCount': 'Batch Delete ({count})',
  'pages.landingPageList.batchDeleteEmpty':
    'Please select landing pages to delete first',
  'pages.landingPageList.batchDeleteConfirmTitle':
    'Delete the selected {count} landing pages?',
  'pages.landingPageList.batchDeleteConfirmContent':
    'This action cannot be undone, and published links will stop working.',
  'pages.landingPageList.batchDeleteSuccess':
    'Deleted {count} landing pages',
  'pages.landingPageList.batchDeleteFailed':
    'Batch delete failed: {message}',
  'pages.landingPageList.batchDeleteFailedShort': 'Batch delete failed',
  'pages.landingPageList.publishSuccess': 'Published successfully!',
  'pages.landingPageList.publishCancelled': 'Unpublished successfully!',
  'pages.landingPageList.publishFailed': 'Publish failed: {message}',
  'pages.landingPageList.operationFailed': 'Operation failed: {message}',
  'pages.landingPageList.operationFailedShort': 'Operation failed',
  'pages.landingPageList.accessCodeGenerated':
    'Access code generated successfully. Please refresh the page and copy again.',
  'pages.landingPageList.accessCodeGenerateFailed':
    'Failed to generate access code: {message}',
  'pages.landingPageList.accessCodeGenerateRetry':
    'Failed to generate access code. Please try again later.',
  'pages.landingPageList.preview': 'Preview',
  'pages.landingPageList.noImage': 'No Image',
  'pages.landingPageList.page': 'Landing Page',
  'pages.landingPageList.identifier': 'Identifier',
  'pages.landingPageList.status': 'Status',
  'pages.landingPageList.published': 'Published',
  'pages.landingPageList.draft': 'Draft',
  'pages.landingPageList.createdAt': 'Created At',
  'pages.landingPageList.actions': 'Actions',
  'pages.landingPageList.publish': 'Publish',
  'pages.landingPageList.unpublish': 'Unpublish',
  'pages.landingPageList.copyLink': 'Copy Link',
  'pages.landingPageList.more': 'More',
  'pages.landingPageList.edit': 'Edit',
  'pages.landingPageList.copyLandingPage': 'Duplicate Landing Page',
  'pages.landingPageList.generateQr': 'Generate QR Code',
  'pages.landingPageList.delete': 'Delete',
  'pages.landingPageList.deleteConfirmTitle':
    'Are you sure you want to delete this landing page?',
  'pages.landingPageList.deleteConfirmContent':
    'This action cannot be undone.',
  'pages.landingPageList.confirm': 'Confirm',
  'pages.landingPageList.cancel': 'Cancel',
  'pages.landingPageList.title': 'Landing Page List',
  'pages.landingPageList.searchPlaceholder': 'Search title or short code',
  'pages.landingPageList.viewStats': 'View Stats',
  'pages.landingPageList.createPage': 'Create New Page',
  'pages.landingPageList.totalRecords': 'Total {total}',

  // Form management
  'pages.formManagement.loadLandingPagesFailed':
    'Failed to load landing pages',
  'pages.formManagement.loadFailed': 'Load failed: {message}',
  'pages.formManagement.loadRetry': 'Load failed. Please try again later.',
  'pages.formManagement.deleteSuccess': 'Deleted successfully',
  'pages.formManagement.deleteFailed': 'Delete failed: {message}',
  'pages.formManagement.deleteRetry': 'Delete failed. Please try again later.',
  'pages.formManagement.exportSuccess': 'Export successful',
  'pages.formManagement.exportFailed': 'Export failed: {message}',
  'pages.formManagement.selectLandingPageWarning':
    'Please select at least one landing page',
  'pages.formManagement.shareLinkCreated':
    'Share link created successfully',
  'pages.formManagement.shareLinkCreateFailed':
    'Failed to create share link: {message}',
  'pages.formManagement.shareLinkCreateRetry':
    'Failed to create share link. Please try again later.',
  'pages.formManagement.shareLinkCopied':
    'Share link copied to clipboard',
  'pages.formManagement.copyRetry': 'Copy failed. Please copy it manually.',
  'pages.formManagement.clearSuccess': 'Cleared successfully',
  'pages.formManagement.clearQueued':
    'The cleanup task is queued in the background. You can continue using the page.',
  'pages.formManagement.clearSuccessWithCount':
    'Cleanup completed. {count} form records were deleted.',
  'pages.formManagement.clearTimeout':
    'Cleanup is still running in the background. Please refresh later.',
  'pages.formManagement.clearFailed': 'Clear failed: {message}',
  'pages.formManagement.clearRetry': 'Clear failed. Please try again later.',
  'pages.formManagement.manualCallbackSuccess': 'Callback successful',
  'pages.formManagement.manualCallbackFailed':
    'Callback failed: {message}',
  'pages.formManagement.manualCallbackRetry':
    'Callback failed. Please try again later.',
  'pages.formManagement.unnamedSku': 'Unnamed SKU',
  'pages.formManagement.title': 'Form Management',
  'pages.formManagement.aiLandingPage': 'AI Landing Page',
  'pages.formManagement.pageType': 'Landing Page Type',
  'pages.formManagement.allPageTypes': 'All Types',
  'pages.formManagement.builderLandingPage': 'Regular Landing Page',
  'pages.formManagement.clearIgnoresFilters': 'This clears all forms in your account, regardless of the current filters.',
  'pages.formManagement.range.all': 'All',
  'pages.formManagement.range.today': 'Today',
  'pages.formManagement.range.7d': 'Last 7 Days',
  'pages.formManagement.range.30d': 'Last 30 Days',
  'pages.formManagement.selectLandingPage': 'Select Landing Page',
  'pages.formManagement.allLandingPages': 'All Landing Pages',
  'pages.formManagement.shareForm': 'Share Forms',
  'pages.formManagement.exportCsv': 'Export CSV',
  'pages.formManagement.clearForm': 'Clear Forms',
  'pages.formManagement.clearConfirmTitle':
    'Are you sure you want to clear all form records?',
  'pages.formManagement.clearConfirmDescription':
    'This action cannot be undone and will permanently delete all form submission records.',
  'pages.formManagement.clearConfirmOk': 'Clear All',
  'pages.formManagement.refresh': 'Refresh',
  'pages.formManagement.monthlyForms': 'Monthly Forms',
  'pages.formManagement.dailyForms': 'Today Forms',
  'pages.formManagement.uniqueUv': 'Unique UV',
  'pages.formManagement.submitTime': 'Submitted At',
  'pages.formManagement.urlSource': 'Referrer URL',
  'pages.formManagement.directVisit': 'Direct Visit',
  'pages.formManagement.location': 'Location',
  'pages.formManagement.unknown': 'Unknown',
  'pages.formManagement.sku': 'SKU',
  'pages.formManagement.callbackStatus': 'Callback Status',
  'pages.formManagement.callback.pending': 'Pending',
  'pages.formManagement.callback.success': 'Callback Sent',
  'pages.formManagement.callback.failed': 'Callback Failed',
  'pages.formManagement.callback.skipped': 'Auto',
  'pages.formManagement.actions': 'Actions',
  'pages.formManagement.view': 'View',
  'pages.formManagement.manualCallback': 'Callback',
  'pages.formManagement.manualCallbackConfirm':
    'Are you sure you want to trigger a manual callback?',
  'pages.formManagement.delete': 'Delete',
  'pages.formManagement.deleteConfirm':
    'Are you sure you want to delete this record?',
  'pages.formManagement.totalRecords': 'Total {total} records',
  'pages.formManagement.detailTitle': 'Form Details',
  'pages.formManagement.close': 'Close',
  'pages.formManagement.landingPage': 'Landing Page',
  'pages.formManagement.pageId': 'Page ID: {id}',
  'pages.formManagement.ipAddress': 'IP Address',
  'pages.formManagement.device': 'Device',
  'pages.formManagement.formData': 'Form Data',
  'pages.formManagement.shareTitle': 'Share Form Data',
  'pages.formManagement.selectPagesToShare':
    'Select landing pages to share:',
  'pages.formManagement.createShareLink': 'Generate Share Link',
  'pages.formManagement.shareLink': 'Share Link:',
  'pages.formManagement.copy': 'Copy',
  'pages.formManagement.shareHint':
    'This link can be opened directly without login. Anyone with the link can view the selected landing pages form data.',
  'pages.formManagement.unknownDevice': 'Unknown Device',
  'pages.formManagement.device.androidPhone': 'Android Phone',
  'pages.formManagement.device.androidTablet': 'Android Tablet',

  'pages.landingPageStats.dataCenter': 'Data center',
  'pages.landingPageStats.dataCenterHint': 'Matches the data center IP/CIDR list in system parameters',
  'pages.landingPageStats.visitsSubtitle': 'Every visit in chronological order, with an optional landing page filter',
  'pages.landingPageStats.filterPage': 'Filter landing page',
  'pages.landingPageStats.filterPagePlaceholder': 'All pages · Search title or ID',
  'pages.landingPageStats.loadingPages': 'Loading landing pages…',
  'pages.landingPageStats.narrowPageSearch': 'Showing the first 50 matches. Refine the title or search by ID.',
  'pages.landingPageStats.loadPagesFailed': 'Could not load landing pages',
  'pages.landingPageStats.filterThisPage': 'Show visits to this page only',
  'pages.landingPageStats.duration': 'Duration',
  'pages.landingPageStats.durationSeconds': '{seconds} s',
  'pages.landingPageStats.allPages': 'Show all landing pages',
  'pages.landingPageStats.export': 'Export',
  'pages.landingPageStats.exporting': 'Exporting',
  'pages.landingPageStats.cancelExport': 'Cancel export',
  'pages.landingPageStats.exportPageHint': 'Select a landing page to export CSV',
  'pages.landingPageStats.exportScopeHint': 'Export all visits for this landing page in the selected period (CSV)',
  'pages.landingPageStats.exportFailed': 'Export failed: {message}',
  'pages.landingPageStats.exportInvalidResponse': 'Invalid export file. Please try again.',
  'pages.landingPageStats.visitRecords': 'Visit records',
  'pages.landingPageStats.visitsNewestFirst': 'Newest visits first',
  'pages.landingPageStats.visitPageInfo': 'Page {page} · {count} records shown',
  'pages.landingPageStats.pageSize': 'Page size',
  'pages.landingPageStats.rowsPerPage': '{count} / page',
  'pages.landingPageStats.previousPage': 'Previous',
  'pages.landingPageStats.nextPage': 'Next',
  'pages.landingPageStats.subtitle': 'View visits by date, with separate statistics for regular and AI landing pages',
  'pages.landingPageStats.regularPages': 'Regular landing pages',
  'pages.landingPageStats.aiPages': 'AI landing pages',
  'pages.landingPageStats.today': 'Today',
  'pages.landingPageStats.yesterday': 'Yesterday',
  'pages.landingPageStats.last7Days': 'Last 7 days',
  'pages.landingPageStats.dateHint': 'System time zone; last 7 days includes today',
  'pages.landingPageStats.retry': 'Retry',
  'pages.landingPageStats.pv': 'Page views (PV)',
  'pages.landingPageStats.uv': 'Visitors (UV)',
  'pages.landingPageStats.uniqueIp': 'Unique IPs',
  'pages.landingPageStats.uvHint': 'Deduplicated by date, route and IP. The 7-day UV adds daily visitor counts.',
  'pages.landingPageStats.pageCount': 'Landing pages of this type',
  'pages.landingPageStats.visiblePv': 'Visible page views (PV)',
  'pages.landingPageStats.visibleUv': 'Visible visitors (UV)',
  'pages.landingPageStats.newestFirst': 'Newest landing page ID first',
  'pages.landingPageStats.visibleHint': 'PV / UV above sum the landing pages on this list page and change with pagination. Visits across multiple landing pages are counted separately.',
  'pages.landingPageStats.noPages': 'No landing pages of this type',
  'pages.landingPageStats.noVisits': 'No visits in this period',
  'pages.landingPageStats.visitedAt': 'Visit time',
  'pages.landingPageStats.routeCode': 'Route code',
  'pages.landingPageStats.visitStatus': 'Visit status',
  'pages.landingPageStats.blocked': 'Blocked',
  'pages.landingPageStats.visited': 'Visited',
  'pages.landingPageStats.detailRangeHint': 'Visits within the selected period only',
  'pages.landingPageStats.mobile': 'Mobile',
  'pages.landingPageStats.desktop': 'Desktop',
  'pages.landingPageStats.title': 'Landing Page Visit Stats',
  'pages.landingPageStats.refresh': 'Refresh',
  'pages.landingPageStats.monthlyPv': 'Last 7 Days PV',
  'pages.landingPageStats.monthlyUv': 'Last 7 Days UV',
  'pages.landingPageStats.todayUv': 'Today UV',
  'pages.landingPageStats.recentDevices': 'Last 7 Days Devices (Top 5)',
  'pages.landingPageStats.recentCountries': 'Last 7 Days Countries (Top 5)',
  'pages.landingPageStats.noData': 'No data',
  'pages.landingPageStats.landingPageTitle': 'Landing Page Title',
  'pages.landingPageStats.tableUv': 'Last 7 Days UV',
  'pages.landingPageStats.tablePv': 'Last 7 Days PV',
  'pages.landingPageStats.pageId': 'ID: {id}',
  'pages.landingPageStats.lastVisit': 'Last Visit',
  'pages.landingPageStats.actions': 'Actions',
  'pages.landingPageStats.details': 'Details',
  'pages.landingPageStats.ipAddress': 'IP Address',
  'pages.landingPageStats.location': 'Location',
  'pages.landingPageStats.unknown': 'Unknown',
  'pages.landingPageStats.source': 'Source',
  'pages.landingPageStats.visitDate': 'Visit Date',
  'pages.landingPageStats.visitTime': 'Visit Time',
  'pages.landingPageStats.device': 'Device',
  'pages.landingPageStats.totalRecords': 'Total {total}',
  'pages.landingPageStats.detailTitle': 'Visit Details - {title}',
  'pages.landingPageStats.rangeStats': 'View Date Range Stats',
  'pages.landingPageStats.loadSummaryFailed':
    'Failed to load stats summary: {message}',
  'pages.landingPageStats.loadDetailFailed':
    'Failed to load visit details: {message}',
  'pages.landingPageStats.loadRangeFailed':
    'Failed to load date range stats: {message}',
  'pages.landingPageStats.loadRetry': 'Load failed. Please try again later.',
  'pages.landingPageStats.unknownError': 'Unknown error',

  'pages.landingPageTemplates.status.draft': 'Draft',
  'pages.landingPageTemplates.status.published': 'Published',
  'pages.landingPageTemplates.loadBaseUrlRetry':
    'Failed to load landing page domain. Please check the system domain settings.',
  'pages.landingPageTemplates.fetchDataFailed': 'Unable to fetch template data',
  'pages.landingPageTemplates.loadTemplatesRetry':
    'Failed to load templates. Please try again later.',
  'pages.landingPageTemplates.loadLandingPagesFailed':
    'Failed to load landing page list',
  'pages.landingPageTemplates.updateSuccess':
    'Template updated successfully',
  'pages.landingPageTemplates.createSuccess':
    'Template created successfully',
  'pages.landingPageTemplates.deleteSuccess': 'Deleted successfully',
  'pages.landingPageTemplates.deleteConfirmTitle':
    'Delete template "{title}"?',
  'pages.landingPageTemplates.copyTitle': '{title} - Copy',
  'pages.landingPageTemplates.copySuccess':
    'Template duplicated successfully',
  'pages.landingPageTemplates.copyFailed': 'Failed to duplicate template',
  'pages.landingPageTemplates.copyRetry':
    'Failed to duplicate template. Please try again later.',
  'pages.landingPageTemplates.permissionDenied':
    'You do not have permission for this action',
  'pages.landingPageTemplates.previewFrameTitle': 'Preview: {id}',
  'pages.landingPageTemplates.noPreview': 'No preview available',
  'pages.landingPageTemplates.domainNotConfigured':
    'Landing page domain is not configured',
  'pages.landingPageTemplates.previewDomainError':
    'Landing page domain is not configured. Please contact an administrator.',
  'pages.landingPageTemplates.previewUnavailable':
    'This template does not have a preview yet',
  'pages.landingPageTemplates.copyTemplate': 'Duplicate Template',
  'pages.landingPageTemplates.previewTemplate': 'Preview Template',
  'pages.landingPageTemplates.editTemplate': 'Edit Template Info',
  'pages.landingPageTemplates.deleteTemplate': 'Delete Template',
  'pages.landingPageTemplates.copy': 'Copy',
  'pages.landingPageTemplates.preview': 'Preview',
  'pages.landingPageTemplates.edit': 'Edit',
  'pages.landingPageTemplates.delete': 'Delete',
  'pages.landingPageTemplates.createCustomTemplate':
    'Create Custom Template',
  'pages.landingPageTemplates.loading': 'Loading templates...',
  'pages.landingPageTemplates.empty': 'No templates yet. Please try again later.',
  'pages.landingPageTemplates.latestTitle': 'Latest Templates',
  'pages.landingPageTemplates.latestSubtitle': 'Discover recently added landing page designs',
  'pages.landingPageTemplates.aiExamples': 'AI Landing Page Examples',
  'pages.landingPageTemplates.aiExamplesSubtitle': 'Copy AI-generated page ideas in one click',
  'pages.landingPageTemplates.emptyAIExamples': 'No AI landing page examples yet.',
  'pages.landingPageTemplates.usageTip':
    'Usage: you can directly duplicate any landing page style from the template library, then fine-tune it with landing page components until it matches your needs.',
  'pages.landingPageTemplates.allTemplates': '📋 All Templates',
  'pages.landingPageTemplates.refresh': 'Refresh',
  'pages.landingPageTemplates.editTitle': 'Edit Template',
  'pages.landingPageTemplates.createTitle': 'Create Template',
  'pages.landingPageTemplates.save': 'Save',
  'pages.landingPageTemplates.create': 'Create',
  'pages.landingPageTemplates.cancel': 'Cancel',
  'pages.landingPageTemplates.sourceLandingPage': 'Source Landing Page',
  'pages.landingPageTemplates.sourceLandingPageRequired':
    'Please select a source landing page',
  'pages.landingPageTemplates.sourceLandingPagePlaceholder':
    'Select an existing landing page',
  'pages.landingPageTemplates.templateName': 'Template Name',
  'pages.landingPageTemplates.templateNameRequired':
    'Please enter a template name',
  'pages.landingPageTemplates.templateNamePlaceholder':
    'Example: Black Friday Ecommerce Template',
  'pages.landingPageTemplates.templateDescription':
    'Template Description',
  'pages.landingPageTemplates.templateDescriptionPlaceholder':
    'Template intro or recommended use case',
  'pages.landingPageTemplates.tags': 'Tags',
  'pages.landingPageTemplates.tagsPlaceholder':
    'Type and press Enter to add tags',
  'pages.landingPageTemplates.minVipLevel': 'Minimum VIP Level',
  'pages.landingPageTemplates.minVipLevelRequired':
    'Please select a VIP level',
  'pages.landingPageTemplates.vipPlaceholder':
    'Select required VIP access',
  'pages.landingPageTemplates.status': 'Status',
  'pages.landingPageTemplates.applyTitle':
    'Duplicate Template into Landing Page',
  'pages.landingPageTemplates.generateLandingPage':
    'Generate Landing Page',
  'pages.landingPageTemplates.newLandingPageName':
    'New Landing Page Name',
  'pages.landingPageTemplates.nameRequired': 'Please enter a name',
  'pages.landingPageTemplates.newLandingPageNamePlaceholder':
    'Example: Black Friday Template - My Version',
  'pages.landingPageTemplates.landingPageDescription':
    'Landing Page Description',
  'pages.landingPageTemplates.landingPageDescriptionPlaceholder':
    'Optional. Helps you remember this landing page purpose',
  'pages.landingPageTemplates.groupName': 'Group Name',
  'pages.landingPageTemplates.groupNamePlaceholder':
    'Used for landing page grouping',
  'pages.landingPageTemplates.groupColor': 'Group Color',
  'pages.landingPageTemplates.groupColorPlaceholder':
    'Example: #1890FF',
  'pages.landingPageTemplates.seoTitle': 'SEO Title',
  'pages.landingPageTemplates.seoTitlePlaceholder':
    'Override the default SEO title from the template',
  'pages.landingPageTemplates.seoDescription': 'SEO Description',
  'pages.landingPageTemplates.seoDescriptionPlaceholder':
    'Override the default SEO description from the template',
  'pages.landingPageTemplates.seoKeywords': 'SEO Keywords',
  'pages.landingPageTemplates.seoKeywordsPlaceholder':
    'Separate multiple keywords with commas',
  'pages.landingPageTemplates.customCode': 'Custom Code',
  'pages.landingPageTemplates.customCodePlaceholder':
    'Add ad pixels or custom scripts here',

  // Loading screen
  'pages.loading.title': 'Loading resources',
  'pages.loading.subtitle':
    'Initial resource loading may take some time, please be patient',

  // Change Password page
  'pages.changePassword.title': 'Change Password',
  'pages.changePassword.oldPassword.placeholder': 'Please enter old password',
  'pages.changePassword.oldPassword.required': 'Please enter old password!',
  'pages.changePassword.newPassword.placeholder': 'Please enter new password',
  'pages.changePassword.newPassword.required': 'Please enter new password!',
  'pages.changePassword.newPassword.length': 'Password must be at least 6 characters!',
  'pages.changePassword.confirmPassword.placeholder': 'Please confirm new password',
  'pages.changePassword.confirmPassword.required': 'Please confirm new password!',
  'pages.changePassword.backToHome': 'Back to Home',
};
